<template>
    <div class="vh-100">
        <input type="hidden" id="omsetSemuaInput" v-model="omsetSemua">
        <input type="hidden" id="omsetKonvensionalInput" v-model="omsetKonvensional">
        <input type="hidden" id="omsetSnapcleanInput" v-model="omsetSnapclean">
        <input type="hidden" id="notaSemuaInput" v-model="notaSemua">
        <input type="hidden" id="notaKonvensionalInput" v-model="notaKonvensional">
        <input type="hidden" id="notaSnapcleanInput" v-model="notaSnapclean">
        <span class="skip-incontext">Lewati</span>
        <div class="header-top bg-white w-100" v-if="!$store.state.metaModule.isWebview">
            <div class="header-top--dashboard w-limit">
                <div class="header-top--left p-x-20 h-100 profile-wrapper hov" @click="routeToAkun">
                    <div class="circular--portrait">
                        <img v-if="owner_photo_profile != ''" v-bind:src="owner_photo_profile"/>
                        <img v-else src="../../assets/icons/ownerprofile.png"/>
                    </div>
                    <div class="profile-id">
                        <div class="f-14 f-semi text-truncate">{{ owner.nama }}</div>
                        <div class="f-12 m-t-min-2 f-c-midgrey text-truncate" v-if="owner.nama_usaha != ''">
                            {{ owner.nama_usaha }}
                        </div>
                        <div class="f-12 m-t-min-2 f-c-midgrey" v-else>.</div>
                    </div>
                </div>
                <div class="header-top--right p-r-20 h-100 notification-bell-wrapper class-context">
                    <div class="notification-bell-item hov" @click="RouteToNotification">
                        <img class="notification-icon" src="../../assets/icons/bell.svg"/>
                        <div class="notification-counter" v-if="notfiUnseen > 0">{{ (notfiUnseen>100) ? "99+" :
                            notfiUnseen
                            }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- CONTENT -->
        <main :class="`${ !this.$store.state.metaModule.isWebview ? 'main-dashboard' : ''} has-bottom-menu`"
              id="konten-data">
            <div class="p-t-16" v-if="notification.title">
                <SOInformation :title="notification.title" v-if="notification.title">
                    <template v-slot:subtitle>
                        <div class="m-d-0">
                            <div v-html="notification.body "></div>
                            <span
                                    class="f-bold"
                                    @click="gotoDetail"
                                    style="color: #c29500;text-decoration: underline;"
                                    v-if="notification.showDetail"
                            >
                                Detail Maintenance
                            </span>
                        </div>
                    </template>
                </SOInformation>
            </div>
            <div class="w-limits extend p-y-16">
                <div v-if="owner.created_at<='2023-01-09 00:00:00'">
                    <div class="p-x-16 p-d-16" v-if="betaConfig!='undefined' && betaConfig.indexOf('AKUTANSI_MKOIN')<0">
                        <div class="rounded p-2" style="border: 1px solid #ffc107;background-color: rgb(255 243 205);">
                            <div class="f-regular f-14 f-c-red " style="color: rgb(106 55 30);">
                                <svg width="16" height="15" viewBox="0 0 16 15" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M15.5 7.5C15.5 11.6421 12.1421 15 8 15C3.85786 15 0.5 11.6421 0.5 7.5C0.5 3.35786 3.85786 0 8 0C12.1421 0 15.5 3.35786 15.5 7.5ZM8.83333 4.16664C8.83333 3.7064 8.46024 3.33331 8 3.33331C7.53976 3.33331 7.16667 3.7064 7.16667 4.16664V7.49997C7.16667 7.96021 7.53976 8.3333 8 8.3333C8.46024 8.3333 8.83333 7.96021 8.83333 7.49997V4.16664ZM8 10C7.53976 10 7.16667 10.3731 7.16667 10.8334C7.16667 11.2936 7.53976 11.6667 8 11.6667H8.008C8.46824 11.6667 8.84133 11.2936 8.84133 10.8334C8.84133 10.3731 8.46824 10 8.008 10H8Z"
                                            fill="#F2C94C"
                                    />
                                </svg>
                                <b>&nbsp; &nbsp; M-Koin </b> Wajib Terintegrasi Dengan Pencatatan Keuangan. <a href="#"
                                                                                                               @click="() => { showMkoinNotIntegrated = true }"
                                                                                                               style="
                                    text-decoration: underline;
                                ">Aktifkan Disini Sekarang. </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="splide-wrapper splide-ann pagination-mod hw-100"
                     v-if="banner.items.length && validateAccess('dashboard.banner')">
                    <div id="splide-ann" class="splide no-arrows hw-100">
                        <div class="splide__track hw-100">
                            <div class="splide__list hw-100">
                                <div
                                        v-for="(banner, index) in banner.items"
                                        :key="index"
                                        @click="bannerAction(banner)"
                                        class="splide__slide"
                                >

                                    <img :src="banner.image" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="separator" style="display: none"></div>
            <div class="w-limit">

                <!-- Placeholder -->
                <div class="ph-item section-emoney-ph w-limit">
                    <div class="ph-picture ph-coin-panel"></div>
                    <div class="ph-picture ph-paylink-panel"></div>
                </div>

                <!-- Main konten -->
                <div class="paylink-wrapper p-x-20 p-t-20 p-d-16 section-emoney-main">
                    <div class="d-flex flex-column justify-content-center paylink-panel" v-if="validateAccess('dashboard.coin')">
                        <div class="row panel-main">
                            <div class="col-md-6 col-sm-6 col-6 left-panel">
                                <div class="row">
                                    <div class="col-md-12 col-sm-12 col-12">
                                        <span class="title-panel-left">Saldo Coin</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 col-sm-12 col-12">
                                        <span class="content-panel-left">{{ this.FormatRupiah(koinOwner,"") }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-sm-6 col-6">
                                <div class="row">
                                    <div class="col-md-6 col-sm-6 col-6 panel-icon" @click="routePembelianCoin">
                                        <div class="icon-panel icon-tarik-saldo"></div>
                                        <div class="text-panel">Isi Saldo</div>
                                    </div>
                                    <div class="col-md-6 col-sm-6 col-6 panel-icon" @click="routeHistoriPembelianCoin">
                                        <div class="icon-panel icon-riwayat"></div>
                                        <div class="text-panel">Riwayat</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <template v-if="validateAccess('dashboard.paylink')">
                        <div class="paylink-panel" v-if="mesinTotal > 0 || saldoPaylink >0 || ispremium == 1">
                            <div class="row panel-main">
                                <div class="col-md-6 col-sm-6 col-6 left-panel">
                                    <div class="row">
                                        <div class="col-md-12 col-sm-12 col-12">
                                            <span class="title-panel-left">Saldo Paylink</span>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12 col-sm-12 col-12">
                                            <span class="content-panel-left">{{ saldoPaylink | currency}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6 col-6">
                                    <div class="row justify-content-end">
                                        <div class="col-md-6 col-sm-6 col-6 panel-icon"
                                             @click="routeHistoriPembelianPaylink">
                                            <div class="icon-panel icon-riwayat"></div>
                                            <div class="text-panel">Riwayat</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="m-0 pb-1 rounded">
                                <div class="col-12 alert-warning">
                                    <!-- temporary hidden -->
                                    <!-- <div class="d-flex p-1 align-items-center">
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                  d="M12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6ZM6.66667 3.33331C6.66667 2.96512 6.36819 2.66664 6 2.66664C5.63181 2.66664 5.33333 2.96512 5.33333 3.33331V5.99998C5.33333 6.36817 5.63181 6.66664 6 6.66664C6.36819 6.66664 6.66667 6.36817 6.66667 5.99998V3.33331ZM6 8.00002C5.63181 8.00002 5.33333 8.2985 5.33333 8.66669C5.33333 9.03488 5.63181 9.33336 6 9.33336H6.0064C6.37459 9.33336 6.67307 9.03488 6.67307 8.66669C6.67307 8.2985 6.37459 8.00002 6.0064 8.00002H6Z"
                                                  fill="#6F7287"/>
                                        </svg>
                                        <div class="f-12 f-c-midgrey pl-2">
                                            Terdapat komplain pembayaran QRIS dalam proses. Anda bisa melihat
                                            <span class="f-c-blue" @click="routeKomplainQris()">disini</span>
                                        </div>
                                    </div> -->
                                    <div class="d-flex p-1 align-items-center">
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                  d="M12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6ZM6.66667 3.33331C6.66667 2.96512 6.36819 2.66664 6 2.66664C5.63181 2.66664 5.33333 2.96512 5.33333 3.33331V5.99998C5.33333 6.36817 5.63181 6.66664 6 6.66664C6.36819 6.66664 6.66667 6.36817 6.66667 5.99998V3.33331ZM6 8.00002C5.63181 8.00002 5.33333 8.2985 5.33333 8.66669C5.33333 9.03488 5.63181 9.33336 6 9.33336H6.0064C6.37459 9.33336 6.67307 9.03488 6.67307 8.66669C6.67307 8.2985 6.37459 8.00002 6.0064 8.00002H6Z"
                                                  fill="#6F7287"/>
                                        </svg>
                                        <div class="f-12 f-c-midgrey pl-2">
                                            Untuk melihat riwayat paylink yang masuk sebelum tgl 22 Feb 2024 Klik
                                            <span class="f-c-blue" @click="routeOldPaylink()">disini</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row footer-main" v-if="ispremium == 0">
                                <div class="col-md-12 col-sm12 col-12">
                                    <span class="text-midgrey" style="width: 100%;">
                                        Upgrade akun menjadi Power Merchant untuk dapat menarik saldo (withdrawal) PayLink.
                                    </span>
                                </div>
                                <div class="col-md-12 col-sm-12 col-12">
                                    <div class="row" @click="routePowermerchant">
                                        <div class="col-md-10 col-sm-10 col-10">
                                            <div class="text-panel-footer-left-blue">
                                                <div class="text-inline-div">Upgrade Akun Sekarang</div>
                                                <div class="icon-inline icon-arrow-right"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row footer-main" v-else>
                                <div class="col-md-7 col-sm-7 col-7">
                                    <div class="row">
                                        <div class="col-md-2 col-sm-2 col-2">
                                            <div class="icon-panel-footer-left icon-verified"></div>
                                        </div>
                                        <div class="col-md-9 col-sm-9 col-9">
                                            <div class="text-panel-footer-left">Power Merchant</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-5 col-sm-5 col-5">
                                    <div class="row">
                                        <div class="col-md-8 col-sm-8 col-8 is_click">
                                            <div class="text-panel-footer-right" @click="upgradePowerMerchant">
                                                Tarik Saldo
                                            </div>
                                        </div>
                                        <div class="col-md-4 col-sm-4 col-4">
                                            <div class="icon-panel-footer-right icon-arrow-right"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="separator-line"></div>
                <!-- SECTION KEUANGAN -->

                <!-- Placeholder -->
                <div class="ph-item section-keuangan-ph w-limit">
                    <div class="ph-col-12 col12main">
                        <div class="ph-row">
                            <div class="ph-col-4 big"></div>
                        </div>
                    </div>
                    <div class="ph-picture ph-keuangan-panel"></div>
                    <div class="ph-picture ph-tindakan-panel"></div>
                </div>

                <!-- Main konten -->

                <div class="ph-item section-pemasukan-ph w-limit">
                    <div class="ph-col-12 col12main">
                        <div class="ph-row">
                            <div class="ph-col-6 big"></div>
                        </div>
                    </div>
                    <div class="ph-picture ph-tindakan-panel"></div>
                    <div class="ph-picture ph-tindakan-panel"></div>
                    <div class="ph-picture ph-tindakan-panel"></div>
                    <div class="m-t-20 ph-picture ph-tindakan-panel"></div>
                </div>

                <!-- Main konten -->
                <div class="section-omset-main" v-if="validateAccess('dashboard.grossProfit')">
                    <div class="omset-container p-x-20 p-y-20">
                        <div class="omzet-wrapper">
                            <div class="f-18 f-bold">
                                Omset Perusahaan <span style="color:#cfcfcf"> • </span>
                                <div class="data-dropdown">
                                    <a class="f-16 f-semi f-c-blue dropdown-toggle" href="#" data-toggle="dropdown">
                                        {{ periode_graph }}
                                    </a>
                                    <div class="dropdown-menu mod">
                                        <a id="graph_bulan_ini" @click="changePeriodeOmset('bulan_ini')"
                                        class="dropdown-item dropdownOmset active">Bulan ini</a>
                                        <a id="graph_hari_ini" @click="changePeriodeOmset('hari_ini')"
                                        class="dropdown-item dropdownOmset">Hari ini</a>
                                    </div>
                                </div>
                            </div>
                            <div class="m-t-12 pill-wrapper">
                                <div class="pill-item active" id="toggle-all">Semua</div>
                                <div class="pill-item" id="toggle-konv">Reguler</div>
                                <div class="pill-item" id="toggle-snap">Self Service</div>
                            </div>
                            <div class="m-t-20 m-d-20">
                                <div class="f-12 f-c-midgrey">{{ tanggalSekarang }}</div>
                                <div class="f-28 lsp f-ln-150" id="omzet-total"></div>
                                <div class="f-12 f-semi f-c-midgrey" id="omzet-nota"></div>
                            </div>
                            <div class="omzet-chart-wrapper m-10-min class-context">
                                <canvas id="omzet-chart" class="omzet-chart"></canvas>
                            </div>
                            <div class="omzet-chart-legend m-t-12">
                                <div class="legend-chart konv f-12 f-c-midgrey">Reguler</div>
                                <div class="legend-chart snap f-12 f-c-midgrey m-l-12">Self Service</div>
                            </div>
                        </div>
                        <div class="section-keuangan-main" v-if="validateAccess('dashboard.accounting')">
                            <div class="section-keuangan-wrapper">
                                <div id="testFunc" class="f-18 f-bold">Keuangan</div>
                                <div class="m-t-12 inner-panel px-3">
                                    <div class="inner-panel-item" @click="RouteToKeuangan">
                                        <div class="f-14 f-c-midgrey">Total Kas Laci</div>
                                        <div class="f-16 f-semi">{{ kasLaciFormat | currency}}</div>
                                    </div>
                                    <div class="inner-panel-item" @click="RouteToBank">
                                        <div class="f-14 f-c-midgrey">Total Kas Bank</div>
                                        <div class="f-16 f-semi">{{ kasBankFormat | currency}}</div>
                                    </div>
                                    <div class="inner-panel-item" @click="RouteToMerchantOnline">
                                        <div class="f-14 f-c-midgrey">Total Kas Merchant Online</div>
                                        <div class="f-16 f-semi">{{ kasMerchantOnlineFormat | currency}}</div>
                                    </div>
                                    <div class="inner-panel-item" @click="RouteToEDC">
                                        <div class="f-14 f-c-midgrey">Total Kas Mesin EDC</div>
                                        <div class="f-16 f-semi">{{ kasEDC | currency}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="separator-line"></div>
                    <!-- SETCION RINCIAN PENDAPATAN -->

                    <div id="detail-earning" class="collapse p-x-20 p-t-16 p-d-4">
                        <template v-if="isLoadingPendapatan">
                            <div class="d-flex justify-content-center">
                                <div class="d-flex" style="gap: 3px;">
                                    <span class="spinner-border spinner-border-sm f-c-midgrey " role="status"
                                          aria-hidden="true"></span>
                                    <span class="f-14 f-c-midgrey">
                                        Memuat data...
                                    </span>
                                </div>
                            </div>
                        </template>
                        <div v-else class="rincian-pendapatan">
                            <div class="pt-3">
                                <div class="f-18 f-bold">Rincian Pendapatan</div>
                                <div class="font-14 text-midgrey text-info-panel"
                                    style="margin-top: 0px !important;margin-bottom: -10px !important"
                                    v-if="totalPendapatan == 0">Tidak ada transaksi pada periode
                                </div>
                                <div v-else>
                                    <p class="font-14 text-midgrey text-info-panel">Nominal ini
                                        belum ditambah dengan pendapatan
                                        lainnya
                                        (Express & Biaya Layanan). Scroll kebawah untuk melihat detail</p>
                                </div>
                                <div class="m-t-24 inner-panel konvensionalPanel" v-if="totalPendapatan1 > 0">
                                    <template v-for="(dataEach, index) in rincianPendapatanKonv">
                                        <div
                                                :key="index"
                                                v-if="dataEach.total > 0"
                                                class="inner-panel-item"
                                                @click="RouteToRincianPendapatan(dataEach.jenis_satuan)"
                                        >
                                            <div class="f-14 f-c-midgrey">{{ dataEach.nama }}</div>
                                            <div class="f-16 f-semi">{{ dataEach.total | currency}}
                                                <span v-if="dataEach.satuan == 'M2'"
                                                    class="suffix">{{ dataEach.jumlah }} M<sup>2</sup></span>
                                                <span v-else
                                                    class="suffix">{{ dataEach.jumlah + " " +  dataEach.satuan}}</span>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                                <div class="m-t-20 inner-panel snapPanel" v-if="totalPendapatan2 > 0">
                                    <div class="inner-panel-item" v-for="dataEachSnap in rincianPendapatanSnap"
                                        v-if="dataEachSnap.total > 0"
                                        @click="RouteToRincianPendapatan(dataEachSnap.jenis_satuan)">
                                        <div class="f-14 f-c-midgrey">{{ dataEachSnap.nama }}</div>
                                        <div class="f-16 f-semi">{{ dataEachSnap.total | currency }}<span class="suffix">{{ dataEachSnap.jumlah + " " +  dataEachSnap.satuan}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="pt-3">
                                <div class="f-18 f-bold">Pendapatan Lainya</div>
                                <div class="font-14 text-midgrey text-info-panel"
                                    style="margin-top: 0px !important;margin-bottom: -10px !important"
                                    v-if="totalPendapatanTambahan == 0">Tidak memiliki pendapatan lainya.
                                </div>
                                <div class="m-t-12 inner-panel" v-else>
                                    <div class="inner-panel-item no-after" v-for="dataLainya in rincianPendapatanLainya"
                                        v-if="dataLainya.total > 0">
                                        <div class="f-14 f-c-midgrey">{{ dataLainya.nama }}</div>
                                        <div class="f-16 f-semi">{{ dataLainya.total | currency }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="pt-3">
                                <div class="f-18 f-bold">Pajak & Diskon</div>
                                <div v-if="totalPajakDiskon > 0" class="font-14 text-midgrey text-info-panel"
                                    style="margin-top:-10px;">
                                    Bagian ini tidak dihitung sebagai omset.
                                </div>
                                <div v-else class="font-14 text-midgrey text-info-panel">
                                    Tidak memiliki transaksi yang menggunakan pajak & diskon.
                                </div>
                                <div class="inner-panel" style="margin-top:-10px;" v-if="totalPajakDiskon > 0">
                                    <div class="inner-panel-item no-after" v-for="eachData in rincianPajakDiskon"
                                        v-if="eachData.total > 0">
                                        <div class="f-14 f-c-midgrey">{{ eachData.nama }}</div>
                                        <div class="f-16 f-semi">{{ eachData.total | currency }}</div>
                                    </div>
                                </div>
                            </div>
                            <br>
                        </div>
                    </div>
                    <div class="detail-earning-btn p-y-20 lsp section-omset-main" data-toggle="collapse"
                         data-target="#detail-earning">
                        <div class="show-more">Lihat Rincian Pendapatan</div>
                        <div class="show-less">Sembunyikan rincian</div>
                    </div>
                </div>

                <div class="section-pemasukan-pengeluaran p-x-20 p-y-20" v-if="validateAccess('dashboard.cashInOut')">
                    <div class="section-keuangan-wrapper m-d-2">
                        <div class="f-18 f-bold" style="margin-bottom: 36px">
                            Penerimaan & Pengeluaran Kas <span style="color:#cfcfcf"> • </span>
                            <div class="data-dropdown">
                                <a class="f-16 f-semi f-c-blue dropdown-toggle" href="#" data-toggle="dropdown">
                                    {{ periode_inout }}
                                </a>
                                <div class="dropdown-menu mod">
                                    <a id="inout_hari_ini" @click="changePeriodePemasukan('hari_ini')"
                                       class="dropdown-item dropdownInout active">Hari ini</a>
                                    <a id="inout_bulan_ini" @click="changePeriodePemasukan('bulan_ini')"
                                       class="dropdown-item dropdownInout">Bulan ini</a>
                                </div>
                            </div>
                        </div>
                        <div class="m-t-12 inner-panel">
                            <div class="inner-panel-item" @click="routeDetailKeuangan('cash')">
                                <div class="f-14 f-c-midgrey">Penerimaan Uang Cash</div>
                                <div class="f-16 f-semi">{{ pemasukanUangCash | currency }}</div>
                            </div>
                            <div class="inner-panel-item" @click="routeDetailKeuangan('debit')">
                                <div class="f-14 f-c-midgrey">Penerimaan Transfer</div>
                                <div class="f-16 f-semi">{{ pemasukanKasDebet | currency }}</div>
                            </div>
                            <div class="inner-panel-item" @click="routeDetailKeuangan('edc')">
                                <div class="f-14 f-c-midgrey">Penerimaan EDC</div>
                                <div class="f-16 f-semi">{{ pemasukanEDC | currency }}</div>
                            </div>
                            <div class="inner-panel-item" v-if="mesinTotal > 0 || saldoPaylink >0"
                                 @click="routeDetailKeuangan('paylink')">
                                <div class="f-14 f-c-midgrey">Penerimaan Paylink</div>
                                <div class="f-16 f-semi">{{ pemasukanPaylink | currency }}</div>
                            </div>
                        </div>
                        <div class="inner-panel" style="margin-top: 6px">
                            <div class="inner-panel-item" @click="routeDetailKeuangan('pengeluaran')">
                                <div class="f-14 f-c-midgrey">Pengeluaran</div>
                                <div class="f-16 f-semi">{{ pengeluaranKeuangan | currency }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="summary-wrapper">
                        <div class="align-items-center d-flex justify-content-between">
                            <div>
                                <div class="f-18 f-bold">
                                    Ringkasan Layanan
                                </div>
                                <div class="f-14 f-c-midgrey">
                                    Per Hari Ini
                                </div>
                            </div>
                            <div
                                @click="flutterNavigate('performa/service')"
                                class="align-items-center d-flex f-c-blue"
                                style="gap: 8px"
                            >
                                <span class="f-semi">Lihat Semua</span>
                                <i class="fas fa-chevron-right"></i>
                            </div>
                        </div>
                        <div
                            class="m-t-12 inner-panel p-x-16 position-relative"
                            :style="`height: ${isSummary ? 'auto' : '425.88px'}`"
                        >
                            <template v-if="isSummary">
                                <div
                                    v-for="service, index in topServiceSummary"
                                    :key="index"
                                    class="d-flex justify-content-between no-after align-items-center p-y-12"
                                    :class="{'border-top': index > 0}"
                                >
                                    <div>
                                        <div class="f-14 f-c-midgrey m-d-2">{{ service.nama_layanan }}</div>
                                        <div class="f-16 f-semi">
                                            {{ service.sum_qty }} {{service.nama_satuan}} <span class="f-c-midgrey f-14"> - {{ service.sum_price | currency }}</span>
                                        </div>
                                    </div>
                                    <span class="bg-gray rounded-lg p-1">
                                        {{ service.nama_outlet }} 
                                    </span>
                                </div>
                            </template>
                            <div class="empty-state absolute" v-else>
                                <div class="empty-state--icon"></div>
                                <div class="f-16 f-bold">Belum ada data</div>
                            </div>
                            
                        </div>
                    </div>
                </div>

                <div class="p-x-20 p-y-16 floating-notification shadow rounded-lg"
                     v-if="notfiNeedAction > 0 && !this.$store.state.metaModule.isWebview">
                    <div class="action-pending-text f-14 f-semi">
                        {{ notfiNeedAction }} Tindakan butuh konfirmasi anda
                    </div>
                    <div class="action-pending-button f-14" @click="RouteToNotification">Lihat</div>
                </div>
            </div>
            <div class="separator" v-if="validateAccess('dashboard.cashInOut')"></div>
            <div class="w-limit section-graph" v-if="validateAccess('dashboard.grossProfit')">
                <!-- SECTION OMZET -->

                <!-- Placeholder -->
                <div class="ph-item section-omset-ph">
                    <div class="ph-col-12 col12main">
                        <div class="ph-row">
                            <div class="ph-col-4 big"></div>
                        </div>
                        <div class="ph-row">
                            <div class="ph-col-8 big"></div>
                        </div>
                    </div>
                    <div class="ph-picture ph-keuangan-panel"></div>
                    <div class="ph-col-12 col12main">
                        <div class="ph-row">
                            <div class="ph-col-4 empty"></div>
                            <div class="ph-col-4 big"></div>
                            <div class="ph-col-4 empty"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="separator" v-if="validateAccess('dashboard.grossProfit')"></div>

            <!-- Placeholder -->
            <div class="d-flex justify-content-between last-content">
                <div>
                    <div class="section-snap-context" v-if="validateAccess('dashboard.machineStatus')">
                        <!-- Snapclean -->
                        <div class="w-limit p-x-20 p-t-24 p-d-24 section-snap-main class-context">
                            <div class="f-18 f-bold">Status Mesin</div>
                            <div class="m-t-12 inner-panel" v-if="mesinTotal > 0" id="snap-status">
                                <div class="p-t-12 p-d-12 p-x-20 f-14 f-c-midgrey">
                                    Dari Total {{ mesinTotal }} Mesin Snapclean.
                                </div>
                                <div class="inner-panel-item-single" style="height: unset;" @click="RouteToSnapRunning">
                                    <div class="f-16 d-flex justify-content-between align-items-center">
                                        <span class="dot dot-blue"></span>
                                        <p class="text-snap m-0">{{ mesinRunning }} Mesin Sedang Berjalan</p>
                                        <div class="flex-1" />
                                        <i class="fas fa-chevron-right f-c-midgrey"></i>
                                    </div>
                                </div>
                                <div class="inner-panel-item-single" style="height: unset;" @click="RouteToSnapOnline">
                                    <div class="f-16 d-flex justify-content-between align-items-center">
                                        <span class="dot dot-green"></span>
                                        <p class="text-snap m-0">{{ mesinOnline }} Mesin Online</p>
                                        <div class="flex-1" />
                                        <i class="fas fa-chevron-right f-c-midgrey"></i>
                                    </div>
                                </div>
                                <div class="inner-panel-item-single" v-if="mesinOffline > 0" @click="RouteToSnapOffline"
                                    style="height: unset;">
                                    <div class="f-16 d-flex justify-content-between align-items-center">
                                        <span class="dot dot-red"></span>
                                        <p class="text-snap m-0">{{ mesinOffline }} Mesin Offline</p>
                                        <div class="flex-1" />
                                        <i class="fas fa-chevron-right f-c-midgrey"></i>
                                    </div>
                                </div>
                                <div class="inner-panel-item-single" v-else style="height: unset;">
                                    <div class="f-16 d-flex align-items-center">
                                        <span class="dot dot-red"></span>
                                        <p class="text-snap m-0 text-midgrey" style="height: unset">Tidak ada mesin yang offline</p>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="m-t-12 snapiklan section-snap-main" @click="toCustomerService"></div>
                        </div>
                    </div>
                    <div class="separator" v-if="validateAccess('dashboard.machineStatus')"></div>
                </div>
                <div>
                    <div class="section-today-context" v-if="validateAccess('dashboard.todayJob')">
                        <!-- Placeholder -->
                        <div class="ph-item section-today-ph w-limit">
                            <div class="ph-col-12 col12main">
                                <div class="ph-row">
                                    <div class="ph-col-6 big"></div>
                                </div>
                            </div>
                            <div class="ph-picture ph-keuangan-panel"></div>
                        </div>
                        <!-- Main konten -->
                        <div class="w-limit p-x-20 p-t-24 p-d-24 section-today-main class-context">
                            <div class="f-18 f-bold">Dilakukan Hari Ini</div>
                            <div class="m-t-12 inner-panel" v-if="statusTransaksi == true">
                                <div class="inner-panel-item no-after">
                                    <div class="f-14 f-c-midgrey">Pengantaran</div>
                                    <div class="f-16">{{ dilakukan_hari_ini.nota_terantar }} dari {{
                                        dilakukan_hari_ini.nota_harus_terantar }} Nota terantar
                                    </div>
                                </div>
                                <div class="inner-panel-item no-after">
                                    <div class="f-14 f-c-midgrey">Penyelesaian Order</div>
                                    <div class="f-16">{{ dilakukan_hari_ini.nota_selesai }} dari {{
                                        dilakukan_hari_ini.nota_harus_selesai }} Nota terselesaikan
                                    </div>
                                </div>
                                <div class="inner-panel-item no-after">
                                    <div class="f-14 f-c-midgrey">Nota Terlambat <span class="f-c-red">*</span></div>
                                    <div class="f-16">{{ dilakukan_hari_ini.nota_terlambat_harus_diselesaikan }} Nota belum
                                        diselesaikan
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="m-t-12 app-kasir section-today-main" @click="toAplikasiKasir"></div>
                                <div class="m-t-12 app-produksi section-today-main" @click="toAplikasiProduksi"></div>
                            </div>
                        </div>
                    </div>
                    <div class="separator" v-if="validateAccess('dashboard.todayJob')"></div>
                </div>
                <div>
                    <div class="section-absensi-context" v-if="validateAccess('dashboard.todayAbsent')">
                        <!-- Placeholder -->
                        <div class="ph-item section-absensi-ph w-limit">
                            <div class="ph-col-12 col12main">
                                <div class="ph-row">
                                    <div class="ph-col-4 big"></div>
                                </div>
                            </div>
                            <div class="ph-picture ph-keuangan-panel"></div>
                        </div>

                        <!-- Main konten -->
                        <div class="w-limit p-x-20 p-t-24 p-d-24 section-absensi-main class-context"
                            v-if="karyawan_harus_hadir > 0">
                            <div class="f-18 f-bold">Absensi Hari Ini</div>
                            <div class="inner-panel m-t-12">
                                <div class="p-t-12 p-d-12 p-x-20 f-14 f-c-midgrey">Dari {{ karyawan_harus_hadir }} karyawan yg
                                    harus hadir
                                </div>
                                <div class="inner-panel-12 d-flex">
                                    <div class="f-16 flex-1 d-flex-align-center">
                                        <div class="icon-16 icon-check-round m-r-8"></div>
                                        <div class="f-16">{{ karyawan_hadir }} Hadir</div>
                                    </div>
                                    <div class="f-16 flex-1 d-flex-align-center">
                                        <div class="icon-16 icon-help-round m-r-8"></div>
                                        <div class="f-16">{{ karyawan_belum_hadir }} Belum Hadir</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            v-else
                            class="m-t-12 karyawanEmpty section-absensi-main class-context"
                            @click="toFormKaryawan"
                        />
                    </div>
                </div>
            </div>
            <div class="separator" style="display:none"></div>
        </main>
        <div class="modal fade" id="modal-lewati-panduan-karyawan" role="dialog">
            <div class="modal-dialog modal-lg  bani-modal">
                <div class="modal-content w-limit">
                    <div class="modal-header">
                        <div class="nav-btn kiri"></div>
                        <h5 class="navbar-title text-center">Batal Mengikuti Panduan</h5>
                        <div class="nav-btn kanan tutup">
                        </div>
                    </div>
                    <div class="modal-body">
                        <p>Anda sedang mengikuti panduan pengguna, batal mengikuti panduan akan menghentikan mode
                            panduan. Apakah Anda yakin ingin keluar dari panduan?</p>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-primary btn-long m-d-20"
                                @click="onboardingKaryawan"
                                data-dismiss="modal">
                            Lanjutkan Panduan
                        </button>
                        <a @click="skipOnboarding(3)" class="m-t-20 f-semi f-12 f-c-blue">Saya Ingin Keluar
                            Dari Mode Panduan</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal mod fade" id="modalPiagam" role="dialog">
            <div class="modal-dialog modal-lg bani-modal">
                <div class="modal-content w-limit">
                    <div class="modal-img">
                        <div class="icon-24 icon-x-white top-right" data-dismiss="modal"></div>
                        <img src="../../assets/img/achievement/piagams.png" alt="">
                    </div>
                    <div class="modal-bodyy w-limit2 w-100 p-x-20 p-y-20">
                        Piagam bertuliskan data <b>(total kuantitas yang anda terima & total konsumen)</b> anda di
                        2020. Pemesanan akan dikenakan biaya <b>Rp 300.000</b> serta pengiriman.
                        <div class="button-wrapper m-t-24 w-limit w-100" @click="piagam">
                            <button class="btn smart-primary" style="border: solid 1px;">Pesan melalui WA</button>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <SOModalAnnouncement
                v-if="showAnnouncement"
                :title="'Pengumuman'"
                :label-btn-primary="'Oke, saya paham'"
                :show-btn-primary="true"
                @action-primary="dismissAnnouncement"
        >
            <template>
                <div class="f-bold f-18 f-c-black m-d-16">
                    "Dropoff" berpindah ke "Transaksi Reguler"
                </div>
                <div class="f-regular f-16 f-c-black m-d-16">
                    Kini transaksi "Layanan Dropoff" bisa anda buat melalui menu "Layanan Reguler" dengan keuntungan:
                    <ul style="padding-left: 24px">
                        <li>Dapat melihat status pengerjaan layanan & nama karyawan yang mengerjakan</li>
                        <li>Dapat menyertakan bukti foto saat pengerjaan layanan</li>
                        <li>Dapat memberikan upah atau komisi pada karyawan yang mengerjakan layanan</li>
                        <li>Dapat menambahkan layanan antar jemput untuk pelanggan</li>
                    </ul>
                </div>
                <div class="video-container m-d-16">
                    <iframe width="100%" src="https://www.youtube.com/embed/Y6fP-pA-1M4" title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>
                </div>
                <div class="f-regular f-16 f-c-black">
                    *Untuk info lebih lanjut hubungi CS Smartlink
                </div>
            </template>
        </SOModalAnnouncement>

        <SOModalAnnouncement
                v-if="showMkoinNotIntegrated"
                :title="'Integrasi Mkoin Pencatatan Keuangan'"
                :label-btn-primary="'Oke, Aktifkan Sekarang'"
                :label-btn-secondary="'Nanti Dulu Saja'"
                :show-btn-primary="true"
                :show-btn-secondary="true"
                @action-primary="konfirmMkoinNotIntegrated"
                @action-secondary="dismissMkoinNotIntegrated"
        >
            <template>
                <div class="f-18 f-c-black m-d-16 f-regular">
                    <br/>
                    <div id="info-integrated-mkoin">
                        <p>Halo Smartowner, saat kamu mengaktifkan mkoin terintegrasi, maka :<br/>
                        <ol>
                            <li>Saat melakukan topup Mkoin, diwajibkan memilih akun sumber dana (kas/bank). setelah
                                M-Koin berhasil masuk, maka nominal tersebut dijurnal dengan KAS/ASSET M-Koin Bertambah
                                (didebit) dan kas/bank otomatis dikurangi (dikredit).&nbsp;
                            </li>
                            <li> Setiap saat menggunakan M-koin, maka otomatis dijurnal dengan mengurangi KAS/ASSET
                                M-Koin (dikredit), dan menambah Biaya Penggunaan Mkoin Smartlink (didebit)
                            </li>
                            <li> Setiap saat menggunakan M-koin, maka otomatis dicatat sebagai BIAYA PER OUTLET yang
                                diakumulasi menjadi per hari.
                            </li>
                        </ol>
                        </p>

                        <a href="#" style="text-decoration: underline" @click="togglesimulasiintegrasimkoin()"
                           id="kliksimulasiintegrasimkoin"><b>Klik DISINI untuk Lihat Contoh Dan Simulasi</b> </a>
                        <p id="simulasiintegrasimkoin" style="display:none;
    border: solid 1px #eaeaea;
    font-size: 16px;
    background: #fbfbfb;
    padding: 10px;
">
                        <ol>
                            <li>Semisal pada tgl 1 anda topup mkoin sebesar 50.000 dengan memilih akun bank
                                BCA.&nbsp;<br/>
                                maka, ada pencatatan jurnal penambahan saldo 50.000 ke KAS/ASSET M-Koin&nbsp;<br/>
                                dan pengurangan saldo bank BCA sebesar 50.000.&nbsp;
                            </li>
                            <li>
                                Ketika tgl 2 jam 10 pagi, terjadi transaksi 1 nota di outlet X,&nbsp;<br/>
                                maka ada pencatatan jurnal saldo Rp.100 yang di kurangani dari KAS/ASSET M-Koin dan&nbsp;<br/>
                                dicatat biaya penggunaan mkoin dioutlet X sebesar Rp.100
                            </li>
                            <li>
                                kemudian tgl 2 jam 12 Siang, terjadi transaksi 1 nota lagi di outlet X,&nbsp;<br/>
                                maka ada pencatatan jurnal saldo Rp.100 yang di kurangani dari KAS/ASSET M-Koin dan&nbsp;<br/>
                                dicatat biaya penggunaan mkoin dioutlet X sebesar Rp.100 sehingga biaya terakumulasi
                                menjadi Rp.200
                            </li>

                        </ol>

                        </p>
                        <hr/>

                    </div>

                </div>
            </template>
        </SOModalAnnouncement>



        <SOModalAnnouncement
                v-if="showMkoinFormNotIntegrated"

                :title="'Form Migrasi dan Catat MKoin'"
                :label-btn-primary="'Aktifkan & Catat Saldo Sekarang'"
                :show-btn-primary="false"
                @action-primary="dismissAnnouncementUpdateOwnerRekening"
        >
            <template>
                <div class="f-18 f-c-black m-d-16 f-regular">
                    <p>Dengan mengaktifkan fitur ini maka sisa saldo mkoin sebesar <b>{{ this.FormatRupiah(koinOwner,"") }}</b> anda akan di catat sebagai jurnal dengan
                        KAS/ASSET M-Koin Bertambah (didebit) dan kas/bank otomatis dikurangi (dikredit).&nbsp;</p>

                    <SOInputSelect
                            :title="'Pilih Kas/Bank yang akan dikurangi Rp.'+this.FormatRupiah(koinOwner,'') "
                            :required="true"
                            :selected="formNotIntegrated.idakun"
                            :placeholder="'Pilih akun...'"
                            :options="optionsAkun"
                            @option-selected="(v) => (formNotIntegrated.idakun = v)"
                    />
                    <hr/>

                <p style="
                    color: #e91e63;
                    border: solid 1px #e91e63;
                    padding: 10px;
                    border-radius: 10px;
                    background: #fff8f8;
                ">
                        Dengan Meng-Klik Tombol Aktifkan dibawah ini, maka saya telah setuju. mulai sekarang sistem akan
                        mencatat sesuai aturan diatas. dan pengaturan ini tidak dapat dibatalkan atau di non aktifkan
                        ulang.&nbsp;</p>

                    <div >
                            <div style="max-width: 400px;float:right;">
                                <SOButton
                                        :text="'Aktifkan dan Mulai Catat Mkoin'"
                                        :primary="true"
                                        :full="true"
                                        :disable="formNotIntegrated.disable"
                                        :loading="formNotIntegrated.loading"
                                        @action="submitFormNotIntegrated"
                                />
                            </div>
                    </div>

                </div>
            </template>
        </SOModalAnnouncement>


        <SOModalAnnouncement
                v-if="showAnnouncementUpdateWAError"
                :title="'Pengumuman'"
                :label-btn-primary="'Oke, saya paham'"
                :show-btn-primary="true"
                @action-primary="dismissAnnouncementUpdateWAError"
        >
            <template>
                <div class="f-18 f-c-black m-d-16 f-regular">
                    <p>Halo Smartowner!!</p>
                    <p class="f-bold">
                        Smartowner, untuk sementara waktu Whatsapp Autosender pada device iOs dengan Whatsapp versi
                        𝟐.𝟐𝟐.𝟒.𝟕𝟓 tidak bisa digunakan.
                        <br/>
                        Saat ini tim kami sedang berupaya semaksimal mungkin untuk mengatasi hal ini.
                        <br/>Mohon maaf atas ketidaknyamanannya, dan terimakasih atas kesediannya untuk menunggu. :pray:


                        Untuk informasi dan bantuan bisa hubungi Whatsapp Customer Support dengan link berikut
                        <b><a href="https://s.id/smartcare" target="_blank">Smartcare</a></b>
                    </p>
                </div>
            </template>
        </SOModalAnnouncement>


        <SOModalAnnouncement
                v-if="showAnnouncementCS"
                :title="'Pengumuman'"
                :label-btn-primary="'Oke, saya paham'"
                :show-btn-primary="true"
                @action-primary="dismissAnnouncementCS"
        >
            <template>
                <div class="f-bold f-18 f-c-black m-d-16">

                    Halo Smartowner !!!
                    Demi meningkatkan pelayanan kami,
                </div>

                <div class="f-regular f-16 f-c-black m-d-16">

                    Mulai <b>2 Januari 2022</b> Jadwal Customer Support Smartlink berubah <br>
                    Kami hadir lebih pagi dan tutup lebih malam, supaya kami punya waktu kebersamaan berasama Smartowner
                    lebih lama :)<br>
                    Berikut jadwalnya :
                    <br>

                    Senin - Sabtu : 07.00 - 22.00 WIB <br>

                    Minggu : 07.00 - 20.00 WIB

                </div>
            </template>
        </SOModalAnnouncement>
        <SOModalAnnouncement
                v-if="showAnnouncementWAAfter"
                :title="'Pengumuman'"
                :label-btn-primary="'Oke, saya paham'"
                :show-btn-primary="true"
                @action-primary="dismissAnnouncementWABefore"
        >
            <template>
                <div class="f-c-black f-16 f-regular">
                    <p class="m-d-16 f-18 f-bold">Halo Smartowner ! Fitur Premium - WA Autosender Telah selesai UPDATE &
                        MAINTENANCE </p>
                    <p class="m-d-16">
                        Sekarang kamu bisa menikmati fitur fitur terbaru dari wa autosender <br/>
                        Perlu diketahui ketika maintenance kemarin, semua pesan di gagalkan dan auto logout. <br/>
                        <b>Sekarang Lakukan scan ulang diperangkatmu agar pesan pesan selanjutnya dapat terkirim secara
                            normal
                        </b>
                    </p>
                    <p>
                        Untuk informasi dan bantuan bisa hubungi Whatsapp Customer Support dengan link berikut
                        <b><a href="https://s.id/smartcare" target="_blank">Smartcare</a></b>
                    </p>
                </div>
            </template>
        </SOModalAnnouncement>

        <!-- modal announcement by API tes -->
        <SOModalAnnouncement
                v-if="announcementModal.show.show"
                :title="announcementModal.show.title"
                :label-btn-primary="(announcementModal.show.btnText ===undefined ? 'Oke, saya paham' : announcementModal.show.btnText)"
                :show-btn-primary="true"
                @action-primary="showAnnouncementModal(announcementModal.show)"
                ref="announcementModal"
        >
            <div class="f-c-black f-16 f-regular  m-t-16" v-html="announcementModal.show.body"/>
        </SOModalAnnouncement>

        <!-- modal banner by API -->
        <SOModalAnnouncement
                v-if="banner.modal.body !== '' && banner.show"
                :title="banner.modal.title"
                :label-btn-primary="'Oke, saya paham'"
                :show-btn-primary="true"
                @action-primary="banner.show = false"
                ref="bannerModal"
        >
            <div class="f-c-black f-16 f-regular m-t-16" v-html="banner.modal.body"/>
        </SOModalAnnouncement>
    </div>
</template>
<script>
    import { mapGetters, mapActions, mapState } from "vuex";
    import Popup from "../../component-items/Popup";
    import SOModalAnnouncement from "@/so-components/global/modal/SOModalAnnouncement";
    import SOButton from "@/so-components/global/ui/SOButton";
    import SOInformation from "@/so-components/global/ui/SOInformation.vue";
    import SOInputSelect from "@/so-components/global/input/SOInputSelect";
    import conn from "../../store/utils/connection";
    import metaApi from "../../store/utils/api-route/metaAPI";

    export default {
        name: "DataDashboard",
        components: {
            SOButton,
            'Popup': Popup,
            SOModalAnnouncement,
            SOInformation,
            SOInputSelect,
        },
        data() {
            return {
                hasOpen: false,
                isLoadingPendapatan: true,
                notification: {
                    title: "",
                    body: "",
                    showDetail: false,
                    routeName: "",
                },
                tanggalSekarang: "",
                owner: {},
                token: '',
                periode_pemasukan: "hari_ini",
                periode_inout: "Hari ini",
                periode_omset: "bulan_ini",
                periode_graph: "Bulan ini",
                rincianPendapatanKonv: [],
                rincianPendapatanSnap: [],
                rincianPendapatanLainya: [],
                rincianPajakDiskon: [],
                omsetSemua: "0",
                omsetKonvensional: "0",
                omsetSnapclean: "0",
                saldoPaylink: "0",
                koinOwner: 0,
                notaSemua: 0,
                notaKonvensional: 0,
                notaSnapclean: 0,
                arrayBulan: [],
                arrayTanggal: [],
                arrayOmsetKonvensional: [],
                arrayOmsetSnap: [],
                kasLaciFormat: "",
                kasBankFormat: "",
                kasMerchantOnlineFormat: "",
                kasEDC: "",
                loadingOnload: false,
                onloadSection: 0,
                loadSection1Status: false,
                loadSection2Status: false,
                loadSection3Status: false,
                nama_owner: 'owner',
                nama_usaha: 'perusahaan',
                idoutlet: '',
                notfiUnseen: 0,
                ispremium: 0,
                notfiNeedAction: 0,
                owner_photo_profile: '',
                dilakukan_hari_ini: {},
                karyawan_hadir: 0,
                karyawan_belum_hadir: 0,
                karyawan_harus_hadir: 0,
                mesinOffline: 0,
                mesinOnline: 0,
                mesinRunning: 0,
                mesinTotal: 1,
                statusTransaksi: true,
                pemasukanKasDebet: "0",
                pemasukanUangCash: "0",
                pemasukanPaylink: "0",
                pemasukanEDC: "0",
                pengeluaranKeuangan: "0",
                totalPendapatan: 0,
                totalPendapatan1: 0,
                totalPendapatan2: 0,
                totalPendapatanTambahan: 0,
                totalPajakDiskon: 0,
                countSection1: 0,
                countSection2: 0,
                countSection3: 0,
                countSection5: 0,
                myChart: null,
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                },
                splideReady: false,
                ownerDropoff: false,
                showAnnouncement: false,

                // bug kasir
                pembenahan: false,
                showAnnouncementBugKasir: false,
                showMkoinNotIntegrated: false,
                showMkoinFormNotIntegrated: false,
                optionsAkun: [],
                formNotIntegrated:{
                    idakun: "",
                    disable:false,
                    loading:false
                },

            // rilis keuangan
                showAnnouncementKeuangan: false,
                showAnnouncementUpdateOwnerRekening: false,
                showAnnouncementUpdateWAError: false,

                // pengumuman cs ganti jam shift
                showAnnouncementCS: false,
                isAnnouncementWAAfter: false,
                showAnnouncementWAAfter: false,

                banner: {
                    items: [],
                    modal: {},
                    show: false,
                },

                announcementModal: {
                    items: [],
                    show: {}
                },
                isLoadingFetchBeta: true,
                outlets: null,

				destroyed: false,
            }
        },
        async mounted() {
            this.getBetaFeatures();
            this.onOpenRincianPendapatan();
            this.getOwnerToken();
            this.getdetailowner();
            this.getDataCheckTransaksi();
            this.hideMainContent();
            this.showSection1();
            this.showSection2();
            this.showSection3();
            // this.showSection4();
            this.showSection5();
            this.intervalRun();
            this.getUnseenNotifications();
            this.getNeedActionNotifications();
            // this.splide();
            // this.checkBugKasir();
            this.getTopServiceSummary()
            this.init();
        },
        methods: {
            async onOpenRincianPendapatan() {
                await $('#detail-earning').on('show.bs.collapse', () => {
                    if (!this.hasOpen) {
                        this.getRincianPendapatanBulanan(this.periode_omset);
                        this.hasOpen = true
                    }
                })
            },
            ...mapActions({
                getDahsboardInfo: `metaModule/getDahsboardInfo`,
                fetchBetaFeature: `metaModule/fetchBetaFeature`,
                fetchKomplainQrisMenu: `metaModule/fetchKomplainQrisMenu`,
                fetchTopServiceSummary: `metaModule/fetchTopServiceSummary`,
            }),
            async getTopServiceSummary() {
                const format = "YYYY-MM-DDTHH:mm:ssZ"
                const date = this.$moment().format('YYYY-MM-DD')
                const payload = {
                    period_start: this.$moment(date + 'T00:00').utc().format(format),
                    period_end: this.$moment(date + 'T23:59').utc().format(format),
                    limit: 5
                }
                await this.fetchTopServiceSummary(payload)
            },
            async getBetaFeatures() {
                this.isLoadingFetchBeta = true
                this.fetchKomplainQrisMenu()
                await this.fetchBetaFeature()
                this.isLoadingFetchBeta = false
            },
            init() {
                this.getDahsboardInfo({})
                    .then((res) => {
                        let {code, data, msg, status} = res.data;

                        if (code === 200 && status) {
                            this.setDataFromApi(data);
                            this.splideReady = true
                        } else {
                            this.$toast.error(msg);
                        }
                    })
                    .then(() => {
                        this.showAnnouncementModal();
                        this.splide();
                    })
                    .catch((e) => {
                        this.$toast.error(e);
                    });
            },
            setDataFromApi(data) {
                if (data.length) {
                    this.banner = {
                        items: [],
                        modal: {},
                        show: false,
                    }
                    this.announcementModal = {
                        items: [],
                        show: {}
                    }
                    data.forEach(items => {
                        switch (items.type) {
                            case 1:
                                this.announcementModal.items.push({
                                    ...items,
                                    show: false,
                                    localStorageKey: 'announcement_' + items.id,
                                })
                                break;
                            case 2:
                                this.notification.title = items.title || "";
                                this.notification.body = items.body || "";
                                this.notification.routeName = items.link || ""
                                this.notification.showDetail = items.link ? true : false;
                                break;
                            case 3:
                                var texts = items.body;
                                var bbTags = new Array("[owner.idowner]", "[owner.nama]", "[owner.telp]", "[owner.jumlah_outlet]", "[content.id]", "[owner.email]");
                                var htmlTags = new Array(this.owner.idowner, this.owner.nama, this.owner.telp, 1, items.id,this.owner.email);

                                for (var i = 0; i < bbTags.length; i++) {
                                    while (texts.indexOf(bbTags[i]) !== -1) {
                                        texts = texts.replace(bbTags[i], htmlTags[i]);
                                    }
                                }
                                items.body = texts;
                                this.banner.items.push(items)
                                break;
                            case 11:
                                localStorage.removeItem('announcement_' + items.id)
                                this.listoutlet().then(() => {

                                    var texts = items.body;
                                    var bbTags = new Array("[owner.idowner]", "[owner.nama]", "[owner.telp]", "[owner.jumlah_outlet]", "[content.id]", "[owner.email]");
                                    var htmlTags = new Array(this.owner.idowner, this.owner.nama, this.owner.telp, this.outlets.length, items.id,this.owner.email);

                                    for (var i = 0; i < bbTags.length; i++) {
                                        while (texts.indexOf(bbTags[i]) !== -1) {
                                            texts = texts.replace(bbTags[i], htmlTags[i]);
                                        }
                                    }
                                    items.body = texts;
                                    items.btnText = "Ingatkan Lagi Nanti";

                                    this.announcementModal.items.push({
                                        ...items,
                                        show: false,
                                        localStorageKey: 'announcement_' + items.id,
                                    })
                                });
                                break;
                            case 12:

                                var texts = items.body;
                                var bbTags = new Array("[owner.idowner]", "[owner.nama]", "[owner.telp]", "[/red]", "[/yellow]", "[/green]");
                                var htmlTags = new Array(this.owner.idowner, this.owner.nama, this.owner.telp, "</font>", "<font>", "</font>");

                                for (var i = 0; i < bbTags.length; i++) {
                                    while (texts.indexOf(bbTags[i]) !== -1) {
                                        texts = texts.replace(bbTags[i], htmlTags[i]);
                                    }
                                }


                                this.notification.title = items.title || "";
                                this.notification.body = texts || "";
                                this.notification.routeName = items.link || ""
                                this.notification.showDetail = items.link ? true : false;
                                break;
                            default:
                                break;
                        }
                    });
                }
            },
            openKilasBalik2023() {
              const flutterConfig = JSON.parse(localStorage.getItem('flutterConfig'))
              if (this.isWebview() && flutterConfig.platform !== 'web') {
                this.$router.push({name: 'kilasbalik'});
              } else {
                window.open("https://dashboard.smartlink.id/kilasbalik")
              }
            },
            showAnnouncementModal(item) {
                if (item) {
                    item.show = false
                    localStorage.setItem(item.localStorageKey, true);
                }
                setTimeout(() => {
                    let i = 0
                    while (i < this.announcementModal.items.length) {
                        if (localStorage.getItem(this.announcementModal.items[i].localStorageKey) !== 'true') {
                            this.announcementModal.show = this.announcementModal.items[i];
                            this.announcementModal.show.show = true;
                            break;
                        }
                        i++
                    }
                }, 1000);
            },
            bannerAction(banner) {
                if (banner.id === 78) {
                    this.$store.commit("metaModule/setOpenBetaModal", true);
                    return;
                }

              if (banner.id === 98) {
                this.openKilasBalik2023();
                return;
              }
              if (banner.link !== "") {
                    window.open(banner.link);
                } else {
                    this.banner.modal = banner
                    this.banner.show = true
                }
            },
            gotoDetail() {
                this.$router.push({name: this.notification.routeName});
            },
            toTop() {
                window.scrollTo(0, 0)
            },
            toFormKaryawan() {
                this.$router.push('/detailakunowner')
            },
            goBroadcast(name, idx) {
                if (name === "valentine") {
                    window.location.href = "https://www.instagram.com/p/CLQCtN8hUnX/?igshid=1qa2rcr0m0uaz";
                } else {
                    this.$router.push({name: name, query: {id: idx}});
                }
            },
            toCustomerService() {
                if (this.owner != null) {
                    window.location.href = "https://api.whatsapp.com/send/?phone=6285234494494&text=Halo%20SmartCare" +
                        "%2C%0Asaya%20" + this.owner.nama +
                        "%0Aemail%20%3A%20" + this.owner.email +
                        "%20%0Atelp%20%3A%20" + this.owner.telp +
                        "%20%0AIngin Bertanya:" +
                        "%20%0A ";
                } else {
                    window.open("https://wa.me/6285234494494", '_blank');
                }
            },
            toAplikasiProduksi() {
                window.open("https://play.google.com/store/apps/details?id=com.sinadme.workshopsinadme", '_blank');
            },
            toAplikasiKasir() {
                window.open("https://play.google.com/store/apps/details?id=com.sinadme.kasirsinadme", '_blank');
            },
            onboardingKaryawan() {
                var self = this
                $(".onboarding-karyawan").addClass("animated pulse infinite")
                const tourKaryawan = new Shepherd.Tour({
                    defaultStepOptions: {
                        scrollTo: {
                            behavior: 'smooth',
                            block: 'center'
                        },
                        // beforeShowPromise: function () {
                        //     return new Promise(function (resolve) {
                        //         setTimeout(function () {
                        //             resolve();
                        //         }, 700)
                        //     });
                        // }
                    },
                    useModalOverlay: true,
                });

                tourKaryawan.addSteps([
                    {
                        classes: 'figure fig-clock',
                        title: 'Selangkah lebih dekat!',
                        text: '<p>Anda akan <b>segera siap</b> menggunakan sistem smartlink. Mari lanjutkan panduan untuk <b>menyiapkan data karyawan</b></p>',
                        buttons: [{
                            classes: "shp-btn-left",
                            secondary: true,
                            text: 'Lewati',
                            action() {
                                return self.showModalLewatiPanduan(tourKaryawan)
                            }
                        }, {
                            classes: "shp-btn-right",
                            text: 'Ok, Lanjut',
                            action() {
                                return tourKaryawan.next()
                            }
                        }],
                    }, {
                        classes: '',
                        title: 'Tambah Data Karyawan',
                        text: '<p>Klik <b>menu karyawan</b> untuk <b>menambahkan, mengubah atau menghapus</b> data karyawan anda</p><div>Klik <b>Menu Karyawan</b> untuk mengelola data karyawan</div>',
                        attachTo: {
                            element: '.onboarding-karyawan',
                            on: 'top'
                        },
                        advanceOn: {
                            selector: '.onboarding-karyawan',
                            event: 'click'
                        },
                    },
                ]);

                tourKaryawan.start()
            },
            showModalLewatiPanduan(tourKaryawan) {
                tourKaryawan.cancel()
                $(".onboarding-karyawan").removeClass("animated pulse infinite")
                $("#modal-lewati-panduan-karyawan").modal({backdrop: 'static', keyboard: false})
            },
            CheckInContextTour() {
                if (this.owner.walkthrough === 3) {
                    if (localStorage.getItem("incontext-device") === undefined || localStorage.getItem("incontext-device") === null || localStorage.getItem("incontext-device") === "") {
                        this.InContextTour()
                        $(".nav-bottom--inner").hide();
                        $(".floating-konfirm").hide();
                        window.scrollTo({top: 0, behavior: 'smooth'});
                    } else {
                        var incontext = localStorage.getItem("incontext-device")
                        var arrayData = JSON.parse(incontext);
                        if (!arrayData.includes(this.owner.idowner)) {
                            this.InContextTour()
                            $(".nav-bottom--inner").hide();
                            $(".floating-konfirm").hide();
                            window.scrollTo({top: 0, behavior: 'smooth'});
                        }
                    }
                }
            },
            skipIncontext(self, tourIncontext) {
                $(".skip-incontext").click(function () {
                    self.closeIncontext(tourIncontext)
                })
            },
            InContextTour() {
                $(".skip-incontext").show();
                var self = this
                const tourIncontext = new Shepherd.Tour({
                    defaultStepOptions: {
                        scrollTo: {
                            behavior: 'smooth',
                            block: 'center'
                        },
                        // beforeShowPromise: function () {
                        //     return new Promise(function (resolve) {
                        //         setTimeout(function () {
                        //             resolve();
                        //         }, 700)
                        //     });
                        // }
                    },
                    useModalOverlay: true,
                });

                tourIncontext.addSteps([
                    {
                        classes: '',
                        title: 'Pemberitahuan & konfirmasi',
                        text: '<p>Lihat semua pemberitahuan terkini & konfirmasi permintaan karyawan disini.</p>',
                        attachTo: {
                            element: '.notification-bell-item',
                            on: 'top'
                        },
                        canClickTarget: false,
                        buttons: [{
                            classes: "shp-btn-right",
                            text: 'Ok, paham',
                            action: tourIncontext.next
                        }],
                    }, {
                        classes: '',
                        title: 'Lihat bisnis Anda berkembang',
                        text: '<p>lihat grafik pertumbuhan omset usaha Anda tiap bulanya disini.</p>',
                        attachTo: {
                            element: '.section-graph',
                            on: 'bottom'
                        },
                        canClickTarget: false,
                        buttons: [{
                            classes: "shp-btn-right",
                            text: 'Keren',
                            action: tourIncontext.next
                        }],
                    }, {
                        classes: '',
                        title: 'Serba digital serba mudah',
                        text: '<p>Pasang snapbridge dan jadikan laundry Anda lebih kekinian. Klik "Beli Sekarang" untuk tahu detailnya. (Hiraukan jika sudah punya)</p>',
                        attachTo: {
                            element: '.section-snap-context',
                            on: 'bottom'
                        },
                        canClickTarget: false,
                        buttons: [{
                            classes: "shp-btn-right",
                            text: 'Lanjut',
                            action: tourIncontext.next
                        }],
                    }, {
                        classes: '',
                        title: 'Aplikasi yang dibutuhkan ',
                        text: '<p>Segera download aplikasi kasir & produksi smartlink dan mulai berbisnis dengan pintar. (Hiraukan jika sudah punya)</p>',
                        attachTo: {
                            element: '.section-today-context',
                            on: 'bottom'
                        },
                        canClickTarget: false,
                        buttons: [{
                            classes: "shp-btn-right",
                            text: 'Ok, paham',
                            action: tourIncontext.next
                        }],
                    }, {
                        classes: '',
                        title: 'Pantau Karyawan ',
                        text: '<p>Lihat status kehadiran karyawan dengan mudah disini.</p>',
                        attachTo: {
                            element: '.section-absensi-context',
                            on: 'bottom'
                        },
                        canClickTarget: false,
                        buttons: [{
                            classes: "shp-btn-right finish-context",
                            text: 'Ok, paham',
                            action: tourIncontext.next
                        }],
                    }, {
                        classes: 'figure fig-clock',
                        title: 'Anda siap Smart Owner!',
                        text: '<p>Terimakasih telah mengikuti panduan sampai selesai. Kami akan terus berkembang untuk membantu Anda menjadi lebih smart & sukses.</p>',
                        buttons: [{
                            classes: "shp-btn-right",
                            text: 'Selesai',
                            action() {
                                return self.closeIncontext(tourIncontext)
                            }
                        }],
                    },
                ]);
                tourIncontext.start()
                this.skipIncontext(self, tourIncontext)
            },
            closeIncontext(tourIncontext) {
                $(".skip-incontext").hide();
                tourIncontext.cancel()
                $(".nav-bottom--inner").show();
                $(".floating-konfirm").show();
                window.scrollTo({top: 0, behavior: 'smooth'});
                var arrayData = []
                var incontext = localStorage.getItem("incontext-device")
                if (incontext !== "" && incontext !== null) {
                    arrayData = JSON.parse(incontext);
                }
                arrayData.push(this.owner.idowner)
                localStorage.setItem("incontext-device", JSON.stringify(arrayData))
            },
            onboardingOutlet() {
                const tour = new Shepherd.Tour({
                    defaultStepOptions: {
                        scrollTo: {
                            behavior: 'smooth',
                            block: 'center'
                        },
                        // beforeShowPromise: function () {
                        //     return new Promise(function (resolve) {
                        //         setTimeout(function () {
                        //             resolve();
                        //         }, 700)
                        //     });
                        // }
                    },
                    useModalOverlay: true,
                });

                tour.addSteps([
                    {
                        classes: 'figure fig-clock',
                        title: 'Mari Mulai!',
                        text: '<p>Mari buat data usaha pertama Anda untuk mulai menggunakan sistem smartlink</p>',
                        buttons: [{
                            classes: "shp-btn-right",
                            text: 'Mulai',
                            action: tour.next
                        }],
                        beforeShowPromise: function () {
                            return new Promise(function (resolve) {
                                resolve();
                            });
                        }
                    },
                    {
                        classes: '',
                        title: 'Tambah data usaha',
                        text: '<p>Mari buat data <b>tempat usaha & layanan</b> yang akan Anda sediakan untuk pelanggan.</p><div>Klik <b>Menu Outlet</b> untuk menuju data outlet</div>',
                        attachTo: {
                            element: '.onboarding-outlet',
                            on: 'top'
                        },
                        advanceOn: {
                            selector: '.onboarding-outlet',
                            event: 'click'
                        },
                    }
                ]);

                setTimeout(() => {
                    $(".shp-btn-right").click(function () {
                        $(".onboarding-outlet").addClass("animated pulse infinite")
                    })
                }, 500)

                tour.start()

            },

            async skipOnboarding(params) {
                $("#modal-lewati-panduan-karyawan").modal("hide")
                try {
                    const datawalkthrough = new FormData
                    datawalkthrough.append('walkthrough', params)
                    const response = await this.$axios.post(this.$baseurl + '/masterData/owner/update_status_walkthrough', datawalkthrough, this.requestHeaders);
                    if (response.data.code === 200) {
                        if (response.data.status === true) {
                            localStorage.setItem("step_walkthrough", params)
                        }
                    } else {
                        this.popupType = "error";
                        this.popupMessage = response.data.msg;
                    }
                } catch (e) {
                    if (!e.code) {
                        this.popupType = "error";
                        this.popupErrorException = e;
                    }
                }
            },
            upgradePowerMerchant() {
                if (this.isWebview()) this.flutterNavigate('qris/withdraw')
                else this.$router.push({name: "ibos", query: {part: 'paylink/info/v2', label: 'Informasi Saldo'}});
                this.smartTrackingClickDashboard('tarik_paylink')

            },
            routePembelianPaylink() {
                this.$router.push({name: "ibos", query: {part: 'paylink/beli/create', label: 'Pembelian Paylink'}});
                this.smartTrackingClickDashboard('topup_paylink')
            },
            routeKomplainQris() {
                this.$router.push({path: "komplain-qris",})
                this.smartTrackingClickDashboard('komplain_qris')
            },
            routeHistoriPembelianPaylink() {
                if (this.isWebview()) this.flutterNavigate('qris/list')
                else this.$router.push({name: "ibos", query: {part: 'paylink/info/v2', label: 'Riwayat Paylink'}});
                this.smartTrackingClickDashboard('riwayat_paylink')
            },
            routePembelianCoin() {
                this.$router.push({name: "ibos", query: {part: 'koin/beli/create', label: 'Pembelian Coin'}});
                this.smartTrackingClickDashboard('topup_mkoin')
            },
            routeHistoriPembelianCoin() {
                if (this.isWebview()) this.flutterNavigate('mcoin/detail')
                else this.$router.push({name: "ibos", query: {part: 'koin/info', label: 'Riwayat Coin'}});

                this.smartTrackingClickDashboard('riwayat_mkoin')
            },
            routePowermerchant() {
                this.$router.push({
                    name: "ibos",
                    query: {part: 'akun-premium/status', label: 'Upgrade Power Merchant'}
                });
                this.smartTrackingClickDashboard('status_power_merchant')
            },
            routeOldPaylink() {
                this.$router.push({name: "ibos", query: {part: 'paylink/info/v2', label: 'Riwayat Paylink'}});
                this.smartTrackingClickDashboard('riwayat_paylink')
            },
            hideMainContent() {
                $(".section-emoney-main").hide()
                $(".section-keuangan-main").hide()
                $(".section-pemasukan-pengeluaran").hide()
                $(".section-omset-main").hide()
                $(".section-today-main").hide()
                $(".section-absensi-main").hide()
                $(".section-informasi-main").hide()
                $(".section-snap-main").hide()
                $(".section-keuangan-ph").hide()
                $(".section-pemasukan-ph").hide()
            },
            showSection1() {
                this.loadingOnload = true
                this.getSaldoCoin()
                this.getSaldoPaylink()
                this.getDataKeuangan()
                $(".section-emoney-ph").show()
                $(".section-keuangan-ph").show()
            },
            hideSection1() {
                this.countSection1 = this.countSection1 + 1
                if (this.countSection1 >= 3) {
                    $(".section-emoney-ph").hide()
                    $(".section-keuangan-ph").hide()
                    $(".section-emoney-main").show()
                    $(".section-keuangan-main").show()
                    // this.showSection2()
                }
            },
            showSection2() {
                this.loadingOnload = true
                $(".section-snap-ph").show()
                this.getDataInOut()
                this.getSnapcleanStatusMachine()
            },
            hideSection2() {
                this.countSection2 = this.countSection2 + 1
                if (this.countSection2 >= 2) {
                    $(".section-snap-ph").hide()
                    $(".section-snap-main").show()
                    $(".section-pemasukan-pengeluaran").show()
                    // this.showSection3()
                }
            },
            showSection3() {
                this.loadingOnload = true
                this.getRangeGraphOmset()

            },
            hideSection3() {
                this.countSection3 = this.countSection3 + 1
                if (this.countSection3 >= 2) {
                    setTimeout(() => {
                        this.chartLine("bulan_ini")
                    }, 500)
                    $(".section-omset-ph").hide()
                    $(".section-omset-main").show()

                    // this.showSection4()
                }
            },
            showSection4() {
                this.loadingOnload = true
                this.getRincianPendapatanBulanan()
            },
            hideSection4() {
                // this.showSection5()
            },
            showSection5() {
                this.loadingOnload = true
                $(".section-absensi-ph").show()
                $(".section-informasi-ph").show()
                $(".section-today-ph").show()
                this.getDataDilakukanHariIni()
                this.getDataAbsensiKaryawanDaily()
            },
            hideSection5() {
                this.countSection5 = this.countSection5 + 1
                if (this.countSection5 >= 2) {
                    $(".section-informasi-ph").hide()
                    $(".section-absensi-ph").hide()
                    $(".section-today-ph").hide()
                    $(".section-absensi-main").show()
                    $(".section-informasi-main").show()
                    $(".section-today-main").show()
                }
            },
            routeToAkun() {
                this.$router.push('/detailakunowner')
                this.smartTrackingClickDashboard('profile')

            },
            RouteToNotification() {
                this.$emit("ToNotification")
                this.smartTrackingClickDashboard('notifikasi')

            },
            routeDetailKeuangan(params) {
                this.$store.commit('detailPenerimaanModule/setDetailPenerimaan', {
                    tipePembayaran: params,
                    periode: this.periode_pemasukan
                })
                this.$router.push({
                    path: `/detail-penerimaan/listoutlet/${params}/${this.periode_pemasukan}`
                })
                // this.$emit("ToChildKeuanganInOut", {"parameter": params, "periode": this.periode_pemasukan})
                this.smartTrackingClickDashboard('detail_penerimaan_'+params);

            },
            RouteToKeuangan() {
                this.$emit("ToChildKeuangan")
                this.smartTrackingClickDashboard('keuangan_kas_laci_outlet');
            },
            RouteToSnapOnline() {
                this.$emit("ToChildSnapOnline")
                this.smartTrackingClickDashboard('snap_mesin_online');
            },
            RouteToSnapOffline() {
                this.$emit("ToChildSnapOffline")
                this.smartTrackingClickDashboard('snap_mesin_offline');
            },
            RouteToSnapRunning() {
                this.$emit("ToChildSnapRunning")
                this.smartTrackingClickDashboard('snap_mesin_running');
            },
            RouteToBank() {
                this.$emit("ToChildBank")
                this.smartTrackingClickDashboard('keuangan_bank');
            },
            RouteToMerchantOnline() {
                this.$emit("ToChildMerchantOnline")
                this.smartTrackingClickDashboard('keuangan_merchant_online');
            },
            RouteToEDC() {
                this.$emit("ToChildEDC")
                this.smartTrackingClickDashboard('keuangan_edc');
            },
            RouteToRincianPendapatan(params) {
                this.$emit("ToChildJenisSatuan", {"parameter": params, "periode": this.periode_omset})
                this.smartTrackingClickDashboard('rincian_pendapatan');

            },
            async getSaldoCoin() {
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/data_coin_owner', this.requestHeaders);
                    if (response.data.code === 200) {
                        if (response.data.status === true) {
                            var koinOwner = response.data.data.jumlah
                            this.koinOwner = koinOwner
                        } else {
                            this.koinOwner = 0
                        }
                        this.hideSection1()
                    } else {
                        this.popupType = "error";
                        this.popupMessage = response.data.msg;
                    }
                } catch (e) {
                    if (!e.code) {
                        this.popupType = "error";
                        this.popupErrorException = e;
                    }
                }
            },

            async getSaldoPaylink() {
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/qrislink/balance', this.requestHeaders);
                    if (response.data.code === 200) {
                        if (response.data.status === true) {
                            this.saldoPaylink = response.data.data.active_balance
                        } else {
                            this.saldoPaylink = 0
                        }
                        this.hideSection1()
                    } else {
                        this.popupType = "error";
                        this.popupMessage = response.data.msg;
                    }
                } catch (e) {
                    if (!e.code) {
                        this.popupType = "error";
                        this.popupErrorException = e;
                    }
                }
            },

            async getDataKeuangan() {
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/data_keuangan_dashboard', this.requestHeaders);
                    if (response.data.code === 200) {
                        if (response.data.status === true) {
                            this.kasLaciFormat = response.data.data.total_kas_laci
                            this.kasBankFormat = response.data.data.total_kas_bank
                            this.kasMerchantOnlineFormat = response.data.data.total_kas_merchant_online
                            this.kasEDC = response.data.data.total_kas_edc
                        } else {
                            this.saldoPaylink = 0
                        }
                    } else {
                        this.popupType = "error";
                        this.popupMessage = response.data.msg;
                    }
                    this.hideSection1()
                } catch (e) {
                    if (!e.code) {
                        this.popupType = "error";
                        this.popupErrorException = e;
                    }
                }
            },

            changePeriodePemasukan(params) {
                $(".dropdownInout").removeClass("active")
                $("#inout_" + params).addClass("active")
                if (params == "bulan_ini") {
                    this.periode_inout = "Bulan ini"
                    this.periode_pemasukan = "bulan_ini"
                } else {
                    this.periode_inout = "Hari ini"
                    this.periode_pemasukan = "hari_ini"
                }
                $(".section-pemasukan-ph").show()
                $(".section-pemasukan-pengeluaran").hide()
                this.getDataInOutPeriode(params)
                this.smartTrackingClickDashboard('change_periode_pemasukan',{"periode":this.periode_inout});

            },

            async getDataInOutPeriode(params = "hari_ini") {
                $("#inout_" + params).addClass("active")
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/periode_pemasukan_dan_pengeluaran_v2?periode=' + params, this.requestHeaders);
                    if (response.data.code === 200) {
                        if (response.data.status === true) {
                            var data = response.data.data
                            this.pemasukanKasDebet = data.pemasukan_debet
                            this.pemasukanUangCash = data.pemasukan_cash
                            this.pemasukanPaylink = data.pemasukan_paylink
                            this.pemasukanEDC = data.pemasukan_edc
                            this.pengeluaranKeuangan = data.pengeluaran_disetujui
                            $(".section-pemasukan-ph").hide()
                            $(".section-pemasukan-pengeluaran").show()
                        } else {
                            this.pemasukanKasDebet = 0
                            this.pemasukanUangCash = 0
                            this.pemasukanPaylink = 0
                            this.pemasukanEDC = 0
                            this.pengeluaranKeuangan = 0
                        }
                    } else {
                        this.popupType = "error";
                        this.popupMessage = response.data.msg;
                    }
                } catch (e) {
                    if (!e.code) {
                        this.popupType = "error";
                        this.popupErrorException = e;
                    }
                }
            },

            async getDataInOut() {
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/periode_pemasukan_dan_pengeluaran_v2?periode=hari_ini', this.requestHeaders);
                    if (response.data.code === 200) {
                        if (response.data.status === true) {
                            var data = response.data.data
                            this.pemasukanKasDebet = data.pemasukan_debet
                            this.pemasukanUangCash = data.pemasukan_cash
                            this.pemasukanPaylink = data.pemasukan_paylink
                            this.pemasukanEDC = data.pemasukan_edc
                            this.pengeluaranKeuangan = data.pengeluaran_disetujui
                        } else {
                            this.pemasukanKasDebet = 0
                            this.pemasukanUangCash = 0
                            this.pemasukanPaylink = 0
                            this.pemasukanEDC = 0
                            this.pengeluaranKeuangan = 0
                        }
                        this.hideSection2()
                    } else {
                        this.popupType = "error";
                        this.popupMessage = response.data.msg;
                    }
                } catch (e) {
                    if (!e.code) {
                        this.popupType = "error";
                        this.popupErrorException = e;
                    }
                }
            },

            async getDataKeuanganBulanIni(params = "bulan_ini") {
                // this.getRincianPendapatanBulanan(params)
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/data_omset_bulan_ini?periode=' + params, this.requestHeaders);
                    if (response.data.code === 200) {
                        if (response.data.status === true) {
                            var eachData = response.data.data
                            this.tanggalSekarang = eachData.tanggal
                            this.omsetSemua = eachData.all_omset
                            this.omsetKonvensional = eachData.konvensional.omset
                            this.omsetSnapclean = eachData.snapclean.omset
                            this.notaSemua = eachData.all_nota
                            this.notaKonvensional = eachData.konvensional.nota
                            this.notaSnapclean = eachData.snapclean.nota
                            $('#omzet-nota').html(eachData.all_nota + " nota");
                            $("#omsetSemuaInput").val(eachData.all_omset)
                        } else {
                            this.omsetSemua = 0
                            this.omsetKonvensional = 0
                            this.omsetSnapclean = 0
                        }

                        if (params == "") {
                            this.chartLine("bulan_ini")
                        } else {
                            this.chartLine(params)
                        }

                        this.hideSection3()
                    } else {
                        this.popupType = "error";
                        this.popupMessage = response.data.msg;
                    }

                } catch (e) {
                    if (!e.code) {
                        this.popupType = "error";
                        this.popupErrorException = e;
                    }
                }
            },

            async SetRememberToken() {
                clearInterval(this.intervalCompare)
                var curentFirebase = localStorage.getItem("curent-token-firebase")
                try {
                    const forms = new FormData;
                    forms.append('token', curentFirebase);
                    const response = await this.$axios.post(this.$baseurl + '/masterData/dashboard/set_remember_token_owner', forms, this.requestHeaders)
                    if (response.data.status === true) {
                        localStorage.setItem("remember-token-firebase", curentFirebase)
                        this.intervalRun()
                    } else {
                        this.popupType = "error";
                        this.popupMessage = response.data.msg;
                    }
                } catch (e) {
                    this.popupType = "error";
                    this.popupErrorException = response.data.msg;
                }
            },

            intervalRun() {
                this.intervalCompare = setInterval(() => {
                    var curentFirebase = localStorage.getItem("curent-token-firebase")
                    var tokenFirebase = localStorage.getItem("remember-token-firebase")
                    if (curentFirebase !== null && curentFirebase !== "" && curentFirebase !== 'undefined') {
                        if (curentFirebase !== tokenFirebase) {
                            this.SetRememberToken()
                        }
                    }
                }, 10000);
            },

            async getdetailowner() {
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/data_detail_owner', this.requestHeaders);
                    var dataowner = response.data.data
                    this.owner = dataowner

                    if (response.data.status === true) {
                        if (dataowner.idfotoprofil != '') {
                            if (dataowner.logo_url != '') {
                                this.owner_photo_profile = 'https://storage.googleapis.com/ember-e-dalbo/' + dataowner.logo_url
                            } else {
                                this.owner_photo_profile = 'https://res.cloudinary.com/sinadme/c_scale,h_200/' + dataowner.idfotoprofil
                            }
                        } else if (dataowner.logo_url != '') {
                            this.owner_photo_profile = 'https://storage.googleapis.com/ember-e-dalbo/' + dataowner.logo_url
                        } else {
                            this.owner_photo_profile = ''
                        }

                        if (!this.isWebview()) {
                            $('#loadingPage').removeClass('overlayLoading');
                            if (dataowner.walkthrough != "" && dataowner.walkthrough != null) {
                                localStorage.setItem("step_walkthrough", dataowner.walkthrough)
                                switch (dataowner.walkthrough) {
                                    case 0:
                                        this.onboardingOutlet()
                                        break;
                                    case 1:
                                        this.getLastOutlet()
                                        break;
                                    case 2:
                                        this.onboardingKaryawan()
                                        break;
                                    default:
                                        break;
                                }
                                this.CheckInContextTour()
                            } else {
                                localStorage.setItem("step_walkthrough", 0)
                                this.onboardingOutlet()
                            }

                        }
                        this.isClickedloader = false;
                        this.nama_owner = dataowner.nama;
                        this.ispremium = dataowner.is_premium;
                        if (dataowner.nama_usaha != '') {
                            this.nama_usaha = dataowner.nama_usaha;
                        } else {
                            this.nama_usaha = 'Nama Perusahaan belum diatur'
                        }

                    }
                } catch (e) {
                    if (!e.code) {
                        this.popupType = "error";
                        this.popupErrorException = e;
                    }
                }
            },

            async listoutlet() {
                try {
                    var idowner = localStorage.getItem('idowner');
                    const res = await this.$axios.get(this.$baseurl + '/masterData/meta/list_outlet_meta?limit=100&idowner=' + idowner, this.requestHeaders)
                    if (res.status === 200) {
                        this.outlets = res.data.data;
                    }
                } catch (e) {
                    this.$catch_error_response(e)
                }
            },

            async getLastOutlet() {
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/outlet_terakhir_dibuat', this.requestHeaders);
                    if (response.data.code === 200) {
                        if (response.data.status === true) {
                            var idoutlet = response.data.data.idoutlet
                            this.$router.push('/AddOutlet?part=outlet&id=' + idoutlet)
                        }
                    } else {
                        this.popupType = "error";
                        this.popupMessage = response.data.msg;
                    }
                } catch (e) {
                    if (!e.code) {
                        this.popupType = "error";
                        this.popupErrorException = e;
                    }
                }
            },
            async getOwnerToken() {
                try {
                    var idowner = localStorage.getItem("idowner")
                    var token = localStorage.getItem("token")
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/data_owner_token' +
                        '?idowner=' + idowner +
                        '&token=' + token
                    );
                    var dataeach = response.data.data
                    if (response.data.code === 200) {
                        if (response.data.status === true) {
                            localStorage.setItem("remember-token-firebase", dataeach.token_firebase)
                        } else {
                            this.logoutApp()
                        }
                    } else {
                        this.$toast.error(response.data.msg)
                    }
                } catch (e) {
                    this.$toast.error(e)
                    if (e.response.data.code === 401) {
                        this.logoutApp()
                        // return
                    }
                    // if (!e.code) {
                    //     this.$catch_error_response(e);
                    // }
                }
            },
            async logoutApp() {
                console.log('logout coy');
                try {
                    const forms = new FormData;
                    forms.append("idowner", localStorage.getItem("idowner"))
                    forms.append("token", localStorage.getItem("token"))
                    const response = await this.$axios.post(this.$baseurl + '/masterData/dashboard/logout_owner_token', forms);
                    if (response.data.code === 200) {
                        if (response.data.status === true) {
                            this.forceLogout()
                        } else {
                            this.$toast.error(response.data.msg)
                        }
                    } else {
                        this.$toast.error(response.data.msg)
                    }
                } catch (e) {
                    if (e.response.data.code === 401) {
                        this.forceLogout()
                        return
                    }
                    if (!e.code) {
                        this.$catch_error_response(e);
                    }
                }
            },
            async getUnseenNotifications() {
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/count_unseen_notifikasi', this.requestHeaders);
                    if (response.data.code === 200) {
                        if (response.data.status === true) {
                            this.notfiUnseen = response.data.data.notifikasi_unseen
                        } else {
                            this.popupType = "error";
                            this.popupMessage = response.data.msg;
                        }
                    } else {
                        this.popupType = "error";
                        this.popupMessage = response.data.msg;
                    }
                } catch (e) {
                    if (!e.code) {
                        this.popupType = "error";
                        this.popupErrorException = e;
                    }
                }
            },

            async getNeedActionNotifications() {
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/data_notification_need_action', this.requestHeaders);
                    if (response.data.code === 200) {
                        if (response.data.status === true) {
                            this.notfiNeedAction = response.data.data.notifikasi_need_action
                        } else {
                            this.popupType = "error";
                            this.popupMessage = response.data.msg;
                        }
                    } else {
                        this.popupType = "error";
                        this.popupMessage = response.data.msg;
                    }
                } catch (e) {
                    if (!e.code) {
                        this.popupType = "error";
                        this.popupErrorException = e;
                    }
                }
            },
            dynamicSort(property) {
                var sortOrder = 1;
                if (property[0] === "-") {
                    sortOrder = -1;
                    property = property.substr(1);
                }
                return function (a, b) {
                    var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
                    return result * sortOrder;
                }
            },
            async getRincianPendapatanBulanan(params) {
                this.isLoadingPendapatan = true
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/rincian_pendapatan_bulanan?periode=' + params, this.requestHeaders);
                    this.hideSection4()
                    if (response.data.code === 200) {
                        if (response.data.status === true) {
                            var dataEach = response.data.data
                            this.rincianPendapatanKonv = []
                            this.rincianPendapatanSnap = []
                            this.rincianPendapatanLainya = []
                            this.rincianPajakDiskon = []
                            this.totalPendapatan1 = 0
                            this.totalPendapatan2 = 0
                            this.totalPendapatan = 0
                            this.totalPendapatanTambahan = 0
                            var totalKeuangan1 = 0
                            var totalKeuangan2 = 0
                            var pendapatanLainya = 0
                            var pajakdiskon = 0
                            for (var i = 0; i < dataEach.length; i++) {
                                if (dataEach[i].type == 1) {
                                    totalKeuangan1 = totalKeuangan1 + dataEach[i].total_harga
                                    this.rincianPendapatanKonv.push({
                                        "jumlah": this.FormatRupiah(dataEach[i].jumlah_satuan.toFixed(2).toString(), ""),
                                        "total": dataEach[i].total_harga,
                                        "satuan": dataEach[i].satuan,
                                        "nama": dataEach[i].nama,
                                        "jenis_satuan": dataEach[i].jenis_satuan
                                    })
                                } else if (dataEach[i].type == 2) {
                                    totalKeuangan2 = totalKeuangan2 + dataEach[i].total_harga
                                    if (dataEach[i].jenis_satuan === "selfservice") {
                                        this.rincianPendapatanSnap.push({
                                            "jumlah": this.FormatRupiah(dataEach[i].jumlah_satuan.toFixed(2).toString(), ""),
                                            "total": dataEach[i].total_harga,
                                            "satuan": dataEach[i].satuan,
                                            "nama": dataEach[i].nama,
                                            "jenis_satuan": dataEach[i].jenis_satuan
                                        })
                                    }
                                } else if (dataEach[i].type == 3) {
                                    pendapatanLainya = dataEach[i].total_harga + pendapatanLainya
                                    this.rincianPendapatanLainya.push({
                                        "total": dataEach[i].total_harga,
                                        "nama": dataEach[i].nama,
                                    })
                                } else {
                                    pajakdiskon = pajakdiskon + dataEach[i].total_harga
                                    this.rincianPajakDiskon.push({
                                        "total": dataEach[i].total_harga,
                                        "nama": dataEach[i].nama,
                                    })
                                }
                            }

                            this.rincianPendapatanLainya.push({
                                "total": 0,
                                "nama": "Biaya Layanan",
                            })

                            this.totalPendapatan1 = totalKeuangan1
                            this.totalPendapatan2 = totalKeuangan2
                            this.totalPendapatan = totalKeuangan1 + totalKeuangan2
                            this.totalPendapatanTambahan = pendapatanLainya
                            this.totalPajakDiskon = pajakdiskon
                        } else {
                            this.popupType = "error";
                            this.popupMessage = response.data.msg;
                        }
                    } else {
                        this.popupType = "error";
                        this.popupMessage = response.data.msg;
                    }
                    this.isLoadingPendapatan = false
                } catch (e) {
                    if (!e.code) {
                        this.popupType = "error";
                        this.popupErrorException = e;
                    }
                    this.isLoadingPendapatan = false
                }
            },
            async getDataDilakukanHariIni() {
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/data_pengantaran_penyelesaian_order', this.requestHeaders);
                    if (response.data.code === 200) {
                        if (response.data.status === true) {
                            var dataEach = response.data.data
                            this.dilakukan_hari_ini = {
                                nota_terantar: dataEach.nota_sudah_diantar,
                                nota_harus_terantar: dataEach.nota_harus_diantar,
                                nota_selesai: dataEach.nota_sudah_diselesaikan,
                                nota_harus_selesai: dataEach.nota_harus_diselesaikan,
                                nota_terlambat_sudah_diselesaikan: dataEach.nota_terlambat_sudah_diselesaikan,
                                nota_terlambat_harus_diselesaikan: dataEach.nota_terlambat_harus_diselesaikan,
                            }
                        } else {
                            this.popupType = "error";
                            this.popupMessage = response.data.msg;
                        }
                        this.hideSection5()
                    } else {
                        this.popupType = "error";
                        this.popupMessage = response.data.msg;
                    }
                } catch (e) {
                    if (!e.code) {
                        this.popupType = "error";
                        this.popupErrorException = e;
                    }
                }
            },
            async getDataCheckTransaksi() {
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/cek_data_transaksi_owner', this.requestHeaders);
                    if (response.data.code === 200) {
                        if (response.data.status === true) {
                            this.statusTransaksi = response.data.data.status_transaksi
                        } else {
                            this.statusTransaksi = false
                        }
                    } else {
                        this.popupType = "error";
                        this.popupMessage = response.data.msg;
                    }
                } catch (e) {
                    if (!e.code) {
                        this.popupType = "error";
                        this.popupErrorException = e;
                    }
                }
            },
            async getSnapcleanStatusMachine() {
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/list_snap_running', this.requestHeaders);
                    if (response.data.code === 200) {
                        if (response.data.status === true) {
                            var eachData = response.data.data;
                            this.mesinOffline = eachData.mesin_offline
                            this.mesinOnline = eachData.mesin_online
                            this.mesinRunning = eachData.mesin_running
                            this.mesinTotal = eachData.mesin_total
                        } else {
                            this.popupType = "error";
                            this.popupMessage = response.data.msg;
                        }
                        this.hideSection2()
                    } else {
                        this.popupType = "error";
                        this.popupMessage = response.data.msg;
                    }
                } catch (e) {
                    if (!e.code) {
                        this.popupType = "error";
                        this.popupErrorException = e;
                    }
                }
            },
            async getDataAbsensiKaryawanDaily() {
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/data_absen_daily', this.requestHeaders);
                    if (response.data.code === 200) {
                        if (response.data.status === true) {
                            var dataEachResponse = response.data.data
                            this.karyawan_hadir = dataEachResponse.karyawan_hadir
                            this.karyawan_belum_hadir = dataEachResponse.karyawan_belum_hadir
                            this.karyawan_harus_hadir = dataEachResponse.karyawan_harus_hadir
                        } else {
                            this.popupType = "error";
                            this.popupMessage = response.data.msg;
                        }
                        this.hideSection5()
                    } else {
                        this.popupType = "error";
                        this.popupMessage = response.data.msg;
                    }
                } catch (e) {
                    if (!e.code) {
                        this.popupType = "error";
                        this.popupErrorException = e;
                    }
                }
            },

            async changePeriodeOmset(params) {
                $(".dropdownOmset").removeClass("active")
                $("#graph_" + params).addClass("active")
                if (params == "hari_ini") {
                    this.periode_graph = "Hari ini"
                } else {
                    this.periode_graph = "Bulan ini"
                }
                this.periode_omset = params
                $(".section-omset-ph").show()
                $(".section-omset-main").hide()
                await this.getRincianPendapatanBulanan(params);
                this.getRangeGraphOmset(params)
                this.smartTrackingClickDashboard('change_omset',{"periode":this.periode_graph});

            },

            async getRangeGraphOmset(params = "bulan_ini") {
                this.getDataKeuanganBulanIni(params)
                var parameter = params
                $("#graph_" + params).addClass("active")
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/data_omset_range_bulan?periode=' + parameter, this.requestHeaders);
                    this.hideSection3()
                    if (response.data.code === 200) {
                        if (response.data.status === true) {
                            var dataRes = response.data.data
                            var dataResSort = dataRes.sort(this.dynamicSort("bulan"));
                            this.arrayTanggal = []
                            this.arrayBulan = []
                            this.arrayOmsetKonvensional = []
                            this.arrayOmsetSnap = []
                            for (var i = 0; i < dataResSort.length; i++) {
                                this.arrayTanggal.push(dataResSort[i].bulan)
                                this.arrayBulan.push(dataResSort[i].nama_bulan)
                                this.arrayOmsetKonvensional.push(dataResSort[i].omset_konvensional)
                                this.arrayOmsetSnap.push(dataResSort[i].omset_snap)
                            }
                        } else {
                            this.popupType = "error";
                            this.popupMessage = response.data.msg;
                        }
                    } else {
                        this.popupType = "error";
                        this.popupMessage = response.data.msg;
                    }
                } catch (e) {
                    if (!e.code) {
                        this.popupType = "error";
                        this.popupErrorException = e;
                    }
                }
            },
            chartLine(params = "bulan_ini") {
                var tanggal = this.arrayTanggal
                var bulan = this.arrayBulan
                var konvensional = this.arrayOmsetKonvensional
                var snapclean = this.arrayOmsetSnap
                Chart.defaults.global.defaultFontFamily = "Overpass";
                var ctx = document.getElementById('omzet-chart').getContext('2d');

                var self = this

                Chart.defaults.LineWithLine = Chart.defaults.line;
                Chart.controllers.LineWithLine = Chart.controllers.line.extend({
                    draw: function (ease) {
                        Chart.controllers.line.prototype.draw.call(this, ease);

                        if (this.chart.tooltip._active && this.chart.tooltip._active.length) {
                            var activePoint = this.chart.tooltip._active[0],
                                ctx = this.chart.ctx,
                                x = activePoint.tooltipPosition().x,
                                topY = this.chart.legend.bottom,
                                bottomY = this.chart.chartArea.bottom;

                            ctx.save();
                            ctx.beginPath();
                            ctx.moveTo(x, topY);
                            ctx.lineTo(x, bottomY);
                            ctx.lineWidth = 1;
                            ctx.strokeStyle = 'rgba(0,0,0,0.15)';
                            ctx.setLineDash([2, 2]);
                            ctx.stroke();
                            ctx.restore();
                        }
                    }
                });

                var gradientBlue = ctx.createLinearGradient(0, 0, 0, 150);
                gradientBlue.addColorStop(0, 'rgba(32,108,255,0.2)');
                gradientBlue.addColorStop(1, 'rgba(32,108,255,0');

                var gradientGreen = ctx.createLinearGradient(0, 0, 0, 150);
                gradientGreen.addColorStop(0, 'rgba(70,217,214,0.2)');
                gradientGreen.addColorStop(1, 'rgba(70,217,214,0)');

                var date = bulan
                if (params == "hari_ini") {
                    date = tanggal
                }

                var lineChartData = {
                    labels: bulan,
                    datasets: [{
                        label: 'Reguler',
                        backgroundColor: gradientBlue,
                        lineTension: 0,
                        borderColor: "rgba(32,108,255,0.75)",
                        pointBackgroundColor: "#206cff",
                        pointRadius: 3,
                        data: konvensional,
                    }, {
                        label: 'Self Service',
                        backgroundColor: gradientGreen,
                        lineTension: 0,
                        borderColor: "rgba(70,217,214,0.75)",
                        pointBackgroundColor: "#46d9d6",
                        pointRadius: 3,
                        data: snapclean,
                    }]
                };

                // Chart Setting
                // myChart.destroy();
                if (self.myChart !== null) {
                    self.myChart.destroy()
                }
                self.myChart = new Chart(ctx, {
                    type: 'LineWithLine',
                    data: lineChartData,
                    options: {
                        datasetFill: true,
                        responsive: true,
                        legend: {
                            display: false
                        },
                        tooltips: {
                            mode: 'index',
                            intersect: false,
                            backgroundColor: '#FFF',
                            titleFontSize: 12,
                            titleFontColor: '#000',
                            titleFontStyle: 'bold',
                            bodyFontColor: '#000',
                            bodyFontSize: 12,
                            titleMarginBottom: 6,
                            borderColor: '#C8D0DD',
                            borderWidth: 1,
                            bodySpacing: 6,
                            xPadding: 8,
                            yPadding: 8,
                            cornerRadius: 3,
                            callbacks: {
                                label: function (tooltipItem, data) {
                                    const datasetLabel = data.datasets[tooltipItem.datasetIndex].label || ' ';
                                    return datasetLabel + ':  ' + FormatRupiah(tooltipItem.yLabel, "Rp");
                                }
                            }
                        },
                        scales: {
                            xAxes: [{
                                gridLines: {
                                    display: false,
                                }
                            }],
                            yAxes: [{
                                gridLines: {
                                    color: '#F1EEFC',
                                    zeroLineColor: "#F1EEFC"
                                },
                                ticks: {
                                    display: false,
                                    beginAtZero: true
                                },
                            }]
                        }
                    }
                });

                function FormatRupiah(num, prefix = "") {
                    var str = num.toString().replace("", ""), parts = false, output = [], i = 1, formatted = null;
                    var startStr = 0
                    if (str.indexOf("-") >= 0) {
                        startStr = 1
                    }
                    if (str.indexOf(".") >= 0) {
                        parts = str.split(".");
                        str = parts[0];
                    }
                    str = str.split("").reverse();
                    var len = str.length
                    if (startStr == 1) {
                        len = (len - 1)
                    }
                    for (var j = 0; j < len; j++) {
                        if (str[j] != ".") {
                            if (j === (len - 1) && startStr === 1) {
                                var lenString = str.length
                                output.push(str[j]);
                                output.push(str[lenString - 1])
                            } else {
                                output.push(str[j]);
                                if (i % 3 == 0 && j < (len - 1)) {
                                    output.push(".");
                                }
                                i++;
                            }
                        }
                    }
                    formatted = output.reverse().join("");
                    return (prefix + formatted + ((parts) ? "," + parts[1].substr(0, 2) : ""));
                }

                var omsetAwal = $("#omsetSemuaInput").val()
                var omsetDoubleAwal = parseFloat(omsetAwal)
                $('#omzet-total').html(FormatRupiah(omsetDoubleAwal.toFixed(2).toString(), "Rp"))

                // Chart Toggles
                $('#toggle-all').click(function () {
                    self.myChart.getDatasetMeta(1).hidden = false;
                    self.myChart.getDatasetMeta(0).hidden = false;
                    self.myChart.update();
                    $(this).siblings().removeClass('active');
                    $(this).addClass('active');
                    var omset = $("#omsetSemuaInput").val()
                    var notaomset = $("#notaSemuaInput").val()
                    var omsetDouble = parseFloat(omset)
                    $('#omzet-total').html(FormatRupiah(omsetDouble.toFixed(2).toString(), "Rp"))
                    $('#omzet-nota').html(notaomset + " nota");

                    $(".konvensionalPanel").show()
                    $(".snapPanel").show()
                    $(".legend-chart.konv").show()
                    $(".legend-chart.snap").show()
                })

                $('#toggle-konv').click(function () {
                    self.myChart.getDatasetMeta(1).hidden = true;
                    self.myChart.getDatasetMeta(0).hidden = false;
                    self.myChart.update();
                    $(this).siblings().removeClass('active');
                    $(this).addClass('active');
                    var notaomset = $("#notaKonvensionalInput").val()
                    var omset = $("#omsetKonvensionalInput").val()
                    var omsetDouble = parseFloat(omset)
                    $('#omzet-total').html(FormatRupiah(omsetDouble.toFixed(2).toString(), "Rp"));
                    $('#omzet-nota').html(notaomset + " nota");

                    $(".konvensionalPanel").show()
                    $(".snapPanel").hide()
                    $(".legend-chart.konv").show()
                    $(".legend-chart.snap").hide()
                })

                $('#toggle-snap').click(function () {
                    self.myChart.getDatasetMeta(0).hidden = true;
                    self.myChart.getDatasetMeta(1).hidden = false;
                    self.myChart.update();
                    $(this).siblings().removeClass('active');
                    $(this).addClass('active');
                    var notaomset = $("#notaSnapcleanInput").val()
                    var omset = $("#omsetSnapcleanInput").val()
                    var omsetDouble = parseFloat(omset)
                    $('#omzet-total').html(FormatRupiah(omsetDouble.toFixed(2).toString(), "Rp"))
                    $('#omzet-nota').html(notaomset + " nota");

                    $(".konvensionalPanel").hide()
                    $(".snapPanel").show()
                    $(".legend-chart.konv").hide()
                    $(".legend-chart.snap").show()
                })

            },

            // SLIDER
            splide() {
                var perpage = 3;
                if (window.matchMedia('screen and (max-width: 1100px)').matches) {
                    perpage = 1;
                } else {
                    if (window.matchMedia('screen and (max-width: 1450px)').matches) {
                        perpage = 2;
                    }
                }
                var option = {
                    perPage: perpage,
                    type: 'loop',
                    rewind: true,
                    autoplay: true,
                    interval: 7000,
                    gap: '12px',
                    padding: {
                        left: '91px',
                        right: '91px',
                    },
                    breakpoints: {
                        620: {
                            padding: {
                                left: '20px',
                                right: '20px',
                            },
                        }
                    }
                };

				if (this.validateAccess('dashboard.banner') && !this.destroyed) new Splide('#splide-ann', option).mount();
                // new Splide('#splide-info', option).mount();
            },
            outlet() {
                this.$router.push('/addoutlet')
            },
            ibos() {
                this.$router.push('/ibos')
            },
            logou() {
                this.$router.push('login')
            }
            ,
            penggajian() {
                this.$router.push('/addpenggajian')
            }
            ,
            karyawan() {
                this.$router.push('/karyawan')
            }
            ,
            menu() {
                this.$router.push('/detailakunowner')
            }
            ,
            toggleMenu() {
                $("#nav-bottom").toggleClass("is-open");
            },
            FormatRupiah(num, prefix) {
                var str = num.toString().replace("", ""), parts = false, output = [], i = 1, formatted = null;
                var startStr = 0
                if (str.indexOf("-") >= 0) {
                    startStr = 1
                }
                if (str.indexOf(".") >= 0) {
                    parts = str.split(".");
                    str = parts[0];
                }
                str = str.split("").reverse();
                var len = str.length
                if (startStr == 1) {
                    len = (len - 1)
                }
                for (var j = 0; j < len; j++) {
                    if (str[j] != ".") {
                        if (j === (len - 1) && startStr === 1) {
                            var lenString = str.length
                            output.push(str[j]);
                            output.push(str[lenString - 1])
                        } else {
                            output.push(str[j]);
                            if (i % 3 == 0 && j < (len - 1)) {
                                output.push(".");
                            }
                            i++;
                        }
                    }
                }
                formatted = output.reverse().join("");
                return (prefix + " " + formatted + ((parts) ? "," + parts[1].substr(0, 2) : ""));
            },
            showModalPiagam() {
                $("#modalPiagam").modal("show");
            },
            piagam() {
                if (this.owner.created_at > "2021-01-01 00:00:01") {
                    alert("Mohon maaf, halaman ini hanya untuk pengguna di tahun 2020");
                } else {
                    window.location.href = "https://api.whatsapp.com/send/?phone=6285234494494&text=Halo%20SmartCare" +
                        "%2C%0Asaya%20mau%20pesan%20piagam%20achievement%202020%2C%0A" +
                        "%20%3A%0ANama%20%3A%20" + this.owner.nama +
                        "%0Aemail%20%3A%20" + this.owner.email +
                        "%20%0Atelp%20%3A%20" + this.owner.telp +
                        "%20%0A%0A";
                }
            },
            async checkDropoff() {
                // try {
                //     const response = await this.$axios.get(this.$baseurl + 'masterData/meta/count_layanan_dropoff',this.requestHeaders)
                //     if (response.status === 200) {
                //         if (response.data.status === true) {
                // 			if (response.data.data > 0) {
                this.ownerDropoff = true

                if (localStorage.getItem("announcement_opened")?.toString() !== "true") {
                    this.showAnnouncement = true
                    localStorage.setItem("announcement_opened", true)
                }
                // }
                this.splideReady = true
                setTimeout(() => {
                    this.splide()
                }, 500)
                //         }
                //     }
                // }catch (e) {
                //
                // }
            },
            openAnnoucement() {
                this.showAnnouncement = true
            },
            dismissAnnouncement() {
                setTimeout(() => {
                    this.showAnnouncement = false
                }, 1000)
            },
            openUpdateKeuangan() {
                this.showAnnouncementKeuangan = true
            },
            openUpdateOwnerRekening() {
                this.showAnnouncementUpdateOwnerRekening = true
            },
            openUpdateBannerWAError() {
                this.showAnnouncementUpdateWAError = true
            },
            openUpdateBannerConference() {
                window.location = 'https://youtu.be/yfOJAu22EUA';
            },
            openUpdateBannerWebinarApril() {
                window.location = 'https://s.id/EraBaruBisnisLaundry';
            },
            openUserSatisfaction() {
                window.location = 'http://s.id/usersurvey';
            },
            dismissMkoinNotIntegrated() {
                setTimeout(() => {
                    this.showMkoinNotIntegrated = false
                }, 1000)
            },
            konfirmMkoinNotIntegrated() {
                this.getAssetsAccount();
                this.showMkoinNotIntegrated = false
                setTimeout(() => {
                    this.showMkoinFormNotIntegrated = true
                }, 200)

            },
            dismissAnnouncementUpdateOwnerRekening() {
                setTimeout(() => {
                    this.showAnnouncementUpdateOwnerRekening = false
                }, 1000)
            },
            dismissAnnouncementUpdateWAError() {
                setTimeout(() => {
                    this.showAnnouncementUpdateWAError = false
                }, 1000)
            },
            dismissAnnouncementCS() {
                setTimeout(() => {
                    this.showAnnouncementCS = false
                }, 1000)
            },
            dismissAnnouncementWABefore() {
                setTimeout(() => {
                    this.showAnnouncementWAAfter = false
                    this.$router.push({name: 'wa_autosender.welcome_page'})
                }, 1000)
            },


            async checkBugKasir() {
                try {
                    const response = await this.$axios.get(this.$baseurl + 'masterData/meta/count_user_autosender', this.requestHeaders)
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            if (response.data.data > 0) {
                                this.isAnnouncementWAAfter = true
                                if (localStorage.getItem("maintenance_wa_after")?.toString() !== "true") {
                                    this.showAnnouncementWAAfter = true
                                    localStorage.setItem("maintenance_wa_after", true)
                                } else {
                                    // await this.checkDropoff()
                                    this.announcementAutoMuncul()
                                }
                            } else {
                                // await this.checkDropoff()
                                this.announcementAutoMuncul()
                            }
                        }
                        this.splideReady = true
                        setTimeout(() => {
                            this.splide()
                        }, 500)
                    }
                } catch (e) {

                }
            },
            announcementAutoMuncul() {
                if (localStorage.getItem("show_announcement_cs")?.toString() !== "true") {
                    this.showAnnouncementCS = true
                    localStorage.setItem("show_announcement_cs", true)
                }
            },
            togglesimulasiintegrasimkoin() {
                $('#simulasiintegrasimkoin').toggle(500);
                var body = $("#modal-announcement .modal-body");
                body.stop().animate({scrollTop: $('#kliksimulasiintegrasimkoin').position().top}, 500, 'swing');

            },
            async getAssetsAccount() {
                if (this.optionsAkun.length <= 0) {
                    const res = await this.$store.dispatch("metaModule/fetchAssetsAccount");
                    if (res.success) {
                         this.optionsAkun = [];
                        this.getListAssetsAccount.forEach((v) => {
                            if(v.idakun!=="1.09.002"){
                                this.optionsAkun = [
                                    ...this.optionsAkun,
                                    {
                                        id: v.idakun,
                                        text: v.nama_akun,
                                    },
                                ];
                            }
                        });
                    } else {
                        this.$toast.error(res.err);
                    }
                }
            },
            async submitFormNotIntegrated(){
                if(this.formNotIntegrated.idakun===""){
                    alert("Pilih ID Akun Terlebih Dahulu");
                    return;
                }
                if(this.formNotIntegrated.idakun===""){
                    alert("Pilih ID Akun Terlebih Dahulu");
                    return;
                }
                this.formNotIntegrated.loading = true
                this.formNotIntegrated.disable = true
                try {
                    let posted = new FormData();

                        posted.append("feature", "AKUTANSI_MKOIN");
                        posted.append("idakun",this.formNotIntegrated.idakun)

                    const res =  await conn.post(metaApi.setBetaFeature,posted,conn.contentType.form)
                    if (res.data.status) {
                        alert("Berhasil Mengintegrasikan Pencatatan Mkoin");
                        window.location.reload();
                    }
                } catch (error) {
                    console.log(error)
                }
                this.formNotIntegrated.loading = false
                this.formNotIntegrated.disable = false

            }
        },
        computed: {
            ...mapGetters("metaModule", {
                getListAssetsAccount: "getListAssetsAccount",
            }),
						...mapState({
							topServiceSummary: state => state.metaModule.topServiceSummary,
						}),

            betaConfig() {
                return this.$store.state.metaModule.betaFeatureOwnerAccess.feature
            },
            showQrisManagementMenu() {
                return this.$store.state.metaModule.showQrisManagementMenu
            },
						isSummary() {
							return this.topServiceSummary.length
						}
        },
		beforeDestroy() {
			this.destroyed = true
		}
    }
</script>

<!-- Style css -->
<style scoped>
    @media only screen and (max-width: 480px) {
        .floating-notification {
            width: 100% !important;
        }
    }
    @media only screen and (max-width: 768px) {
        .omset-container,
        .paylink-wrapper,
        .section-pemasukan-pengeluaran,
        .rincian-pendapatan,    
        .last-content {
            display: block !important;
        }
        .omzet-wrapper {
            max-width: unset;
        }
    }
    @media only screen and (min-width: 769px;) {
        .omzet-wrapper {
            max-width: 48%;
        }
    }
    .rincian-pendapatan,
    .omset-container,
    .paylink-wrapper,
    .section-pemasukan-pengeluaran {
        display: flex;
        gap: 16px;
    }
    .omset-container > *,
    .paylink-wrapper > *,
    .section-pemasukan-pengeluaran > *,
    .rincian-pendapatan > *,
    .last-content > * {
        flex: 1;
    }

    .floating-notification {
        position: fixed;
        bottom: 82px;
        background: white;
        z-index: 20;
        display: flex;
        justify-content: space-between;
        left: 50%;
        transform: translateX(-50%);
        width: 480px;
    }

    .skip-incontext {
        display: none;
        color: white;
        position: fixed;
        top: 16px;
        left: 25px;
        z-index: 99999;
    }

    .circular--portrait {
        position: relative;
        width: 30px;
        height: 30px;
        overflow: hidden;
        border-radius: 50%;
        margin-right: 10px;
    }

    .circular--portrait img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .header-top--dashboard {
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .header-top--dashboard .profile-wrapper {
        display: flex;
        align-items: center;
        margin-left: -10px;
    }

    .header-top--dashboard .profile-wrapper .profile-picture {
        height: 30px;
        width: 30px;
        border: 1px solid rgba(0, 0, 0, 0.015);
        margin-right: 10px;
        border-radius: 50%;
        background-size: cover;
        background-position: center;
    }

    .header-top--dashboard .notification-bell-wrapper,
    .header-top--dashboard .nav-menu-wrapper {
        display: flex;
        align-items: center;
    }

    .notification-bell-wrapper .notification-bell-item {
        /*margin-right: 10px;*/
        padding: 5px 7px;
        background: #E2F0FF;
        color: #206CFF;
        display: flex;
        align-items: center;
        border-radius: 3px;
    }

    .navigation-menu-item {
        font-size: 14px;
        padding: 5px 8px;
        background: #206CFF;
        color: #fff;
        display: flex;
        align-items: center;
        border-radius: 3px;
    }

    .navigation-menu-icon {
        height: 18px;
        margin-right: 5px;
    }

    .navigation-menu-text {
        height: 20px;
    }

    .header-top--dashboard .notification-bell-wrapper .notification-icon {
        display: inline-block;
    }


    .header-top--dashboard .notification-bell-wrapper .notification-counter {
        background: none;
        display: block;
        font-weight: bold;
        color: #206CFF;
        padding-left: 5px;
        height: 20px;
        float: right;
    }

    .header-top--dashboard .notification-bell-wrapper .notification-counter:after {
        content: "";
        display: block;
        width: 100%;
        clear: both;
    }

    .main-dashboard {
        padding-top: 50px;
    }

    .slide-card {
        background: linear-gradient(114.48deg, #AFC9FF 0%, #4A85FF 100%);
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
        border-radius: 3px;
        padding: 12px 0px;
    }

    .text-omset {
        font-weight: bold;
        font-size: 14px;
        line-height: 21px;
        display: flex;
        align-items: center;
        letter-spacing: -0.02em;
        color: #FFFFFF;
    }

    .text-rupiah {
        font-weight: bold;
        font-size: 24px;
        line-height: 37px;
        display: flex;
        align-items: center;
        letter-spacing: -0.02em;
        color: #FFFFFF;
    }

    .text-detail {
        font-weight: normal;
        font-size: 12px;
        line-height: 18px;
        display: flex;
        align-items: center;
        letter-spacing: -0.02em;
        color: rgba(255, 255, 255, 0.55);
    }

    .status-dashboard {
        background: #FFFFFF;
        box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.07);
        border-radius: 3px;
    }

    .status {
        padding: 10px 16px;
    }

    /* DASHBOARD */
    .paylink-panel {
        background: linear-gradient(90deg, #E6F7FE 0%, #FFFFFF 100%);
        border: 1px solid rgba(0, 0, 0, 0.07);
        border-radius: 5px;
        overflow: hidden;
        padding: 0px 15px;
        margin-bottom: 14px;
    }

    .paylink-panel .paylink-top-panel {
        background: linear-gradient(270deg, #4CA1AF 0%, #1C54C4 100%);
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 41px;
        padding-left: 15px;
        padding-right: 15px;
    }

    .paylink-panel .paylink-balance {
        color: white;
        font-weight: 600;
    }

    .paylink-panel .paylink-bottom-panel {
        display: flex;
        justify-content: space-around;
        padding: 8px 0px;
    }

    .paylink-panel .paylink-bottom-panel .icon-panel {
        width: 28px;
        height: 28px;
        margin: auto;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
    }

    .icon-panel {
        width: 28px;
        height: 28px;
        margin: auto;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
    }

    .paylink-panel .paylink-bottom-panel .text-panel {
        color: #206cff;
        letter-spacing: -0.02em;
        font-size: 13px;
        margin-top: 4px;
        font-weight: 600;
    }

    .paylink-panel .paylink-bottom-panel .item-panel-wrapper {
        padding: 8px;
    }

    .inner-panel {
        border: 1px solid #EDEDED;
        border-radius: 3px;
    }

    .inner-panel .inner-panel-item {
        padding: 12px 48px 12px 16px;
        position: relative;
    }

    .inner-panel .inner-panel-item:not(:first-child),
    .inner-panel .inner-panel-12:not(:first-child) {
        border-top: 1px solid #EDEDED;
    }

    .inner-panel .inner-panel-item span.suffix:before {
        content: ' — '
    }

    .inner-panel .inner-panel-item span.suffix {
        font-size: 14px;
        color: #6F7287;
    }

    .inner-panel .inner-panel-12 {
        padding: 12px 16px;
    }

    .action-pending-button {
        background: #206CFF;
        border-radius: 3px;
        color: white;
        padding: 2px 8px;
    }

    .pill-wrapper {
        display: flex;
    }

    .pill-wrapper .pill-item {
        margin-left: 4px;
        color: #206CFF;
        font-size: 14px;
        letter-spacing: -0.02em;
        border-radius: 100px;
        padding: 4px 12px;
        border: 1px solid #C8D0DD;
        font-weight: 600;
        transition: background-color .25s;
    }

    .pill-wrapper .pill-item:first-child {
        margin-left: 0px;
    }

    .pill-wrapper .pill-item.active {
        color: white;
        background-color: #206CFF;
        border-color: rgba(0, 0, 0, 0);
    }

    .f-28 {
        font-size: 28px;
    }

    .omzet-chart-wrapper {
        padding-top: 60%;
        position: relative;
    }

    .omzet-chart {
        width: 100% !important;
        height: 100% !important;
        position: absolute;
        top: 0px;
        left: 0px;
    }

    .omzet-chart-legend {
        display: flex;
        justify-content: center;
    }

    .omzet-chart-legend .legend-chart {
        display: flex;
        align-items: center;
    }

    .omzet-chart-legend .legend-chart:before {
        content: '';
        width: 8px;
        height: 8px;
        margin-right: 5px;
        border-radius: 50%;
    }

    .omzet-chart-legend .legend-chart.konv:before {
        background: #206CFF;
    }

    .omzet-chart-legend .legend-chart.snap:before {
        background: #46D9D6;
    }

    #detail-earning + .detail-earning-btn .show-less,
    #detail-earning.show + .detail-earning-btn .show-more {
        display: none
    }

    #detail-earning.show + .detail-earning-btn .show-less,
    #detail-earning + .detail-earning-btn .show-more {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .detail-earning-btn {
        color: #206CFF;
        text-align: center;
        font-weight: 600;
    }

    .splide-wrapper {
        position: relative;
    }

    .splide-wrapper.splide-ann {
        /* 320 x 116 ( + padding 20px ) */
        padding-top: 32.23%;
        position: relative;
    }

    .pagination-mod {
        margin-bottom: calc(16px + 8px);
    }

    ul.splide__pagination {
        z-index: auto;
        bottom: calc(-16px - 8px);
    }

    .splide-wrapper.splide-ann .splide {
        position: absolute;
        left: 0;
        top: 0;
    }

    .splide-wrapper .splide__slide {
        background: white;
        border-radius: 5px;
        overflow: hidden;
        background-position: center;
        background-size: cover;
    }

    .splide-wrapper .splide__slide img {
        vertical-align: middle;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .splide-wrapper.splide-info .splide__slide {
        border: 1px solid #C8D0DD;
        border-radius: 3px;
        display: flex;
        flex-direction: column;
    }

    .splide-wrapper.splide-info .splide__slide img {
        height: 120px;
        border-bottom: 1px solid #C8D0DD;
    }

    .splide-wrapper.splide-info .splide__slide .splide-info-text {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        padding: 12px 16px;
    }

    .w-limit.extend {
        max-width: 620px;
    }

    .hw-100 {
        height: 100%;
        width: 100%;
    }

    .m-t-min-2 {
        margin-top: -2px;
    }

    @media screen and (min-width: 400px) {
        .splide-wrapper.splide-ann {
            padding-top: 130px;
        }
    }

    @media screen and (min-width: 620px) {

        .splide-wrapper .splide__track {
            border-radius: 5px;
        }

        .splide-wrapper.edge-fade:before,
        .splide-wrapper.edge-fade:after {
            content: '';
            width: 90px;
            height: 100%;
            position: absolute;
            bottom: 0;
        }

        .splide-wrapper.edge-fade:before {
            background-image: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
            left: 0;
            z-index: 1;
        }

        .splide-wrapper.edge-fade:after {
            background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
            right: 0;
        }

        .header-top {
            z-index: 9 !important;
        }
    }

    .button-menus-right {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        margin: 8px 0px 0px 0px;
        padding: 7px 8px 5px 8px;
        background-color: #206CFF;
        color: white;
        border-radius: 3px;
        border: none;

        font-family: Overpass;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 150%;

        float: right;
        margin-right: -15px;
    }

    .button-menus-right:active {
        border: none;
        background-color: #1e67f3;
        color: white;
    }

    .button-menus-right:focus {
        border: none;
        background-color: #1e67f3;
        color: white;
    }

    .button-menus-right > img {
        width: 18px;
        margin: 0px 3px 3px 3px;
    }

    .notify {
        margin-right: -10%;
    }

    .notify-label {
        float: left;
        padding: 2px 0px 0px 4px;

        position: absolute;
        width: 57px;
        height: 34px;
        border-radius: 3px;
        margin: 8px 10px 0px 0px;
        margin-left: -15px;
        background: #E2F0FF;
        border-radius: 3px;

        font-family: Overpass;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 21px;
        display: flex;
        align-items: center;
        text-align: center;

        /* Smartlink Blue */

        color: #206CFF;
    }

    .notify-label > img {
        padding: 0px 5px 2px 2px;
        margin: auto;
    }

    .notify-label > span {
        margin: auto;
        margin-left: -6px;
    }

    .panel-icon {
        text-align: center;
    }

    .panel-icon .text-panel {
        font-family: Overpass;
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 150%;
        text-align: center;
        letter-spacing: -0.02em;
        color: #206CFF;
    }

    .panel-main {
        padding: 10px;
    }

    .left-panel .title-panel-left {
        font-family: Overpass;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 150%;
        letter-spacing: -0.02em;
        color: #6F7287;
    }

    .left-panel .content-panel-left {
        font-family: Overpass;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 155%;
        letter-spacing: -0.02em;
        color: #000000;
    }

    .icon-panel-footer-left {
        width: 20px;
        height: 20px;
        margin: 0px;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
    }

    .footer-main {
        padding: 10px 10px;
        border-top: 1px solid rgba(0, 0, 0, 0.07);
    }

    .text-panel-footer-left {
        margin-left: -5px;
        margin-top: 1px;
        font-family: Overpass;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 150%;
        color: #6F7287;
    }

    .icon-panel-footer-right {
        width: 20px;
        height: 20px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        margin-left: 0;
        margin-top: 1px;
    }

    .text-panel-footer-left-blue {
        text-align: left;
        margin-top: 1px;
        font-family: Overpass;
        font-style: normal;
        font-weight: 600;
        font-size: 15px;
        line-height: 150%;
        letter-spacing: -0.02em;
        color: #206CFF;
    }

    .text-panel-footer-right {
        text-align: right;
        margin-right: -20px;
        margin-top: 1px;
        font-family: Overpass;
        font-style: normal;
        font-weight: 600;
        font-size: 15px;
        line-height: 150%;
        letter-spacing: -0.02em;
        color: #206CFF;
    }

    .menu-panel {
        margin-top: -7px;
        margin-right: 3px;
    }

    .col12main {
        padding: 0;
    }

    .ph-item {
        border: none;
    }

    .ph-coin-panel {
        height: 76px;
    }

    .ph-paylink-panel {
        height: 112px;
    }

    .ph-keuangan-panel {
        height: 138px;
    }

    .ph-tindakan-panel {
        height: 42px;
    }

    .text-inline-div {
        display: inline-block;
    }

    .icon-inline {
        position: absolute;
        width: 20px;
        height: 20px;
        margin: 0px;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        display: inline-block;
        margin-left: 10px;
    }

    .text-midgrey {
        width: 288px;
        height: 36px;
        left: 16px;
        top: 80px;
        font-family: Overpass;
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
        line-height: 150%;
        display: flex;
        align-items: center;
        letter-spacing: -0.02em;
        color: #6F7287;
        margin-bottom: 10px;
        margin-top: 10px;
    }

    .is_click {
        cursor: pointer;
    }

    .dot {
        width: 8px;
        height: 8px;
        left: 5px;
        border-radius: 8px;
        display: inline-block;
    }

    .dot-blue {
        background: #206CFF;
    }

    .dot-green {
        background: #6FCF97;
    }

    .dot-red {
        background: #EB5757;
    }

    .text-snap {
        font-size: 14px;
        display: inline-block;
        margin-left: 5px;
    }

    .karyawanEmpty {
        background-image: url('../../assets/icons/empty-karyawan.svg');
        background-position: center;
        background-repeat: no-repeat;
        height: 130px;
        margin-bottom: 20px;
    }

    .snapiklan {
        background-image: url('../../assets/icons/snapiklan.svg');
        background-position: center;
        background-repeat: no-repeat;
        height: 130px;
        margin-bottom: 20px;
    }

    .app-kasir {
        background-image: url('../../assets/icons/empty-aplikasi-kasir.svg');
        background-position: center;
        background-repeat: no-repeat;
        height: 130px;
        margin-bottom: 20px;
    }

    .app-produksi {
        background-image: url('../../assets/icons/empty-aplikasi-produksi.svg');
        background-position: center;
        background-repeat: no-repeat;
        height: 130px;
        margin-bottom: 20px;
    }

    .inner-panel-item-single {
        height: 45px;
        border-top: 1px solid #EDEDED;
        padding-left: 16px;
        position: relative;
        outline: none !important;
    }

    .text-info-panel {
        font-size: 14px;
        line-height: 150%;
        letter-spacing: -0.02em;
    }

    .select-customize {
        font-family: Overpass;
        border: none !important;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 155%;
        color: #206CFF;
        background: none !important;
        margin-bottom: 10px;
        margin-left: -5px;
    }

    .select-customize:focus {
        border: none !important;
        outline: none !important;
        background: none !important;
    }

    .select-customize:active {
        border: none !important;
        outline: none !important;
        background: none !important;
    }

    .m-10-min {
        margin-left: -10px;
        margin-right: -10px;
    }

    .modal {
        overflow: hidden;
        left: auto !important;
    }

    .data-dropdown {
        position: relative !important;
        display: inline-block;
    }

    .dropdown-menu {
        top: 20px !important;
        position: absolute !important;
    }

    .dropdown-menu.show {
        transform: none !important;
    }

    .modal-img {
        text-align: center;
        /* background: blue; */
        padding: 30px;
        background: linear-gradient(300deg, #0C3483 0%, #A2B6DF 100%, #6B8CCE 100%);
    }

    .modal-img img {
        width: auto;
        max-height: 240px;
    }

    .icon-x-white {
        background-image: url('../../assets/img/achievement/close-x-white.svg');
    }

    .top-right {
        position: absolute;
        right: 20px;
        top: 16px;
    }

    .video-container {
        position: relative;
        padding-bottom: 56.25%;
        padding-top: 30px;
        height: 0;
        overflow: hidden;
    }

    .video-container iframe, .video-container object, .video-container embed {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    #snap-status > div {
        padding: 14px;
    }
    #snap-status .dot {
        margin-right: 8px;
    }
</style>